import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from '../../services/alerts.service';
import { FilterService } from '../../services/filter.service';
import { LoaderService } from '../../services/loader.service';
import { BaseService } from '../../shared/services/base.service';
import { StorageService } from '../../shared/services/storage.service';
import { DynamicPopUpComponent } from '../data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { DialogService } from '../dialog/dialog.service';
import { RolePermissionService } from '../../shared/services/role-permission.service';
import get_ from 'lodash-es/get';
import { UtilService } from '../../services/util.service';
import { Location } from '@angular/common';
import { FormService } from '../form/form.service';
import { forkJoin } from 'rxjs';
import { PreferenceService } from '../../shared/services/preference.service';
import { AppService } from '../../shared/services/app.service';
import dayjs from 'dayjs';
import { DateRangeConfig } from '../daterangepicker/dateconfig.service';
import { ManageFilterComponent } from '../data-grid/manage-filter/manage-filter.component';
import { DialogModalSize } from '../dialog/dialog-ref';
import { ModalSize, SmartModalService } from '../../services/smart-modal.service';
import { LabelQuestion } from '../form/models/question-label.model';
import { TextboxQuestion } from '../form/models/question-textbox.model';
import { DropdownQuestion } from '../form/models/question-dropdown.model';
import { QuestionBase } from '../form/models/question-base.model';
import { CheckboxQuestion } from '../form/models/question-checkbox.model';
import { TextareaQuestion } from '../form/models/question-textarea.model';
import { DateRangePickerQuestion } from '../form/models/question-daterangepicker.model';
declare var jQuery: any;
import moment from 'proxies/dayjs';
import { EditGrid } from '../form/models/edit-grid.model';
import { HiddenQuestion } from '../form/models/question-hidden.model';
import { CustomFormQuestion } from '../form/models/question-custom-form.model';
import { ModalService } from '../../services/modal.service';
import { PopupFormComponent } from '../popupform/popupform.component';

@Component({
    selector: 'app-bulk-entry-main',
    templateUrl: './bulk-entry-main.component.html',
    styleUrls: ['./bulk-entry-main.component.scss'],
    standalone: false
})
export class BulkEntryMainComponent implements OnInit {

  @Output() listen_changes: EventEmitter<any> = new EventEmitter();
  // @Input() config: any = { resource: 'specimen_bulk_entry_editable_grid' };
  config: any = {};
  public filterFormGroup: any = false;
  data: any = {};
  @ViewChild('kxFilter') kxFilter: ElementRef;
  @Input() form: any;
  userForm: FormGroup;
  settings: any;
  selectedItems: any[] = [];
  propagateChange = (_: any) => { };
  selectedIndices: boolean[] = [];                                         // Selected Index checkbox
  private _editableGridData: any = { filter: false };
  private _currentData: any = {};
  searchConfig: any = { save_filter: true, hideUgfilter: true, hideSaveAs: true };
  currentSort: Map<string, number> = new Map();
  sortObject: any;
  filterFieldGroup: any;
  defaultDynamicfilter: any;
  filterFormMapping: any;
  // dropdownValueMaster: any[] = [];
  public dummyFilterFormGroup: any = false;
  tableInitalized: boolean = false;
  is_grid_sorted: boolean = true;
  private questionsSub = {};
  questionMapping: any = {};
  fieldGroup: any = [];
  labelCol: any;
  flag: boolean;
  isMobile: boolean;
  eg_grid_data: any[] = [];
  setting_eg_data: boolean = false; // To track if data is being set
  dataIndex: number = 0; // To track where we are in the nestedFields array
  hoveredPopoverCell: string | null = null;               // Cell currently hovered, drives the popover render
  setGridDataInterval: any;
  bloodBankOrdersToggle: false;


  constructor(private fb: FormBuilder, public baseService: BaseService, public dialogService: DialogService, public loader: LoaderService, public filterService: FilterService, public alerts: AlertsService, private route: ActivatedRoute, private storageService: StorageService, public Router: Router, public locationCommon: Location, public injector: Injector, private rolePermissionService: RolePermissionService, public utilService: UtilService, public formService: FormService, public preferenceService?: PreferenceService, public appService?: AppService, private cdRef?: ChangeDetectorRef, public smartModalService?: SmartModalService, public modalService?: ModalService) {
    this._editableGridData['tableInitalized'] = false;
    this._editableGridData.drag_started = true;
  }

  ngOnInit() {
    this.isMobile = this.utilService.isOnlyMobile();
    this.formService.setEditableGrid(true);
    this.config.resource = this.form.controls.tests.question_component.question.resource;
    this.config.filterAr = [];
    this.searchConfig.saveKey = this.config.resource + "_list_config";
    //getting the json for the info
    this.getResourceDef(this.config.resource);
    let res = this.form != undefined && this.form.controls != undefined && this.form.controls.tests != undefined && this.form.controls.tests.question_component != undefined && this.form.controls.tests.question_component.question.resource != undefined ? this.form.controls.tests.question_component.question.resource : '';
    this.data['accessionIdentifierUncheck'] = this.checkPermission('accessionIdentifierUncheck', this.form.controls.tests.question_component.question.resource, 'diagnostic');
    this.getMethodValueSet();
  }

  checkPermission(action_name, resource, application) {
    try {
      return this.rolePermissionService.checkAccessPermission(action_name, resource, application);
    } catch (error) {
      return false;
    }
  }

  initialiseForm() {
    this.userForm = this.fb.group({
      users: this.fb.array([])
    });
  }

  initiateForm(nestedFields?) { // Initating each and every control in Grid
    //this function clones the value in an object for checkbox functionality
    const startTime = performance.now();
    // if (this._editableGridData && this._editableGridData.listBlocks) {
    //   this._editableGridData.fields = this.formService.buildQuestions(this._editableGridData.listBlocks.fields);
    // }
    if (this.userForm != undefined) {
      const control = this.userForm.get('users') as FormArray;
      control.clear();
      if (nestedFields) {
        this._editableGridData.nestedFields = nestedFields;
      } else {
        this._editableGridData.nestedFields = this.setNestedeQuest(this._editableGridData.items, this._editableGridData.listBlocks.fields) || [];
      }
      console.log("nestedFields", this._editableGridData.nestedFields);
      this._editableGridData.items.forEach((element, index) => { // Creating grid rows if item exist
        let group: any = {};
        this._editableGridData.nestedFields[index].forEach(field => {
          //setUpdateValue sets value of each control
          let val = this.setUpdateValue(field, element);
          group[field.key] = field.required ? new FormControl(val, Validators.required) : new FormControl(val);
          //this will save each question in form control which will let us know the current question in each control
          group[field.key]['question_component'] = { "question": field };
        });
        control.push(new FormGroup(group, Validators.required));
        //fires dependent
        this.setDependentUpdate(control, index);
      });
      if (this.settings.selectall != undefined && this.settings.selectall) {
        this.value = this.selectedItems != undefined ? this.selectedItems : [];
      }
      else {
        this.value = this._editableGridData.items;
      }
      this.startPushingData();
      // let obj = { object: this._editableGridData.items, type: "data_binded", editableGrid: this.editableTable.controls.editableRows['controls'] };
      // this.listenEvent(obj);
      setTimeout(() => {
        // this.setDefaultRow();
        if (this.settings.draggable) {
          if (this._editableGridData.resource != undefined) {
            let key = this._editableGridData.resource + "_list_config";
            this._editableGridData.user_preference_json = key;
            this.getFieldsOrder(key);
            // this.HidetoggleVisibility(true, true);
            if (this._editableGridData['tableInitalized']) {
              this._editableGridData['tableInitalized'] = false;
            }
          }
        }
        setTimeout(() => {
          if (this._editableGridData.items.length > 0) {
            for (let item of this._editableGridData.items) {
              // for resultType 'numeric' criticalFlag mapping
              if (item.abnormalValueInterpretation) {
                const inputs = document.getElementById('resultType_' + item.index);
                const serviceItemLabels = document.getElementById('serviceItemName_' + item.index);
                this.setColor(inputs, serviceItemLabels);
              }

              // for resultType 'dropdown' criticalFlag mapping
              if (item.resultType == 'dropdown') {
                const inputs = document.getElementById('resultType_' + item.index);
                const serviceItemLabels = document.getElementById('serviceItemName_' + item.index);
                if (item.criticalValue && item.value && item.criticalValue === item.value) {
                  this.setColor(inputs, serviceItemLabels);
                  this.setResultCritical(item.index, true);
                } else {
                  inputs?.classList.remove("showFontColor");
                  serviceItemLabels?.classList.remove("showFontColor");
                  this.setResultCritical(item.index, false);
                }
              }
            }
          }
        }, 500);
      }, 1000);
    }
  }

  // sets isResultCritical on the form row and the grid data (it is sent to the backend)
  setResultCritical(index: number, isCritical: boolean) {
    const control = this.userForm?.controls?.users?.['controls']?.[index]?.controls?.isResultCritical;
    if (control) {
      if (control.question_component?.question) {
        control.question_component.question.value = isCritical;
      }
      control.setValue(isCritical);
    }
    if (this._editableGridData?.items?.[index]) {
      this._editableGridData.items[index]['isResultCritical'] = isCritical;
    }
    // selectedItems (the rows posted to the backend) are snapshots taken in onItemChecked, which runs before this
    const selectedItem = this.selectedItems?.find(x => x.index === index);
    if (selectedItem) {
      selectedItem['isResultCritical'] = isCritical;
    }
  }

  setColor(inputs, serviceItemLabels) {
    if (inputs && serviceItemLabels) {
      inputs.classList.add("showFontColor");
      serviceItemLabels.classList.add("showFontColor");
    } else {
      inputs?.classList.remove("showFontColor");
      serviceItemLabels?.classList.remove("showFontColor");
    }
  }

  startPushingData() {
    if (this.setGridDataInterval) {
      clearInterval(this.setGridDataInterval); // clear existing interval
    }

    // setting the data in batches
    this.setGridDataInterval = setInterval(() => {
      if (this.dataIndex < this._editableGridData.nestedFields.length && !this.setting_eg_data) {
        this.setting_eg_data = true;
        const batch = this._editableGridData.nestedFields.slice(this.dataIndex, this.dataIndex + 200);

        this.eg_grid_data = [...this.eg_grid_data, ...batch];
        // update the index to point to the next set of items
        this.dataIndex += 200;

        this.setting_eg_data = false;
        // if all the items set, clear the interval
        if (this.dataIndex >= this._editableGridData.nestedFields.length) {
          clearInterval(this.setGridDataInterval);
          console.log("All data has been pushed.");
        }
      }
    }, 200);
  }

  setupDraggableGrid() {
    if (this._editableGridData.resource) {
      const key = `${this._editableGridData.resource}_list_config`;
      this._editableGridData.user_preference_json = key;
      this.getFieldsOrder(key);
      this._editableGridData['tableInitalized'] = this._editableGridData['tableInitalized'] ? false : undefined;
    }
  }


  ngAfterViewChecked() {
    if (this.settings && this.settings.draggable && !this._editableGridData.tableInitalized && jQuery('#editable-grid' + this._editableGridData.resource).length > -1) {
      this._editableGridData.tableInitalized = true;
      console.log("inside ngAfterViewChecked")
      if (this._editableGridData['dragStarted'] && jQuery('#editable-grid')) {
        this.addDragListner();
      } else {
        setTimeout(() => {
          this.addDragListner();
        }, 2000);
      }
    }
  }

  //sets value of each control
  setUpdateValue(field, element) {
    if (field.type == "number" || field.fieldType == "number") {
      return element[field.key] || 0;
    }
    if (field.type == "boolean" || field.fieldType == "boolean") {
      return element[field.key] || false;
    }
    else {
      return element[field.key] || "";
    }
  }
  //*******************************************fires dependent initially as in of update******************************************************* */
  setDependentUpdate(control: FormArray, index: number) {
    const nestedFields = this._editableGridData.nestedFields[index] || [];

    nestedFields.forEach(field => {
      if (field.dependents?.length > 0) {
        const event = {
          "val": control.controls[index]['controls'][field.key].value,
          "question": field,
          "index": index
        };
        // this.onValueChanged(event, control.controls[index], index);
      }
    });
  }

  changeControls(field, index) {
    try {
      if (!this.isConversionAllowed(field, index)) {
        return;
      }
      this.loader.showSpinner();
      console.log("field is ", field);
      console.log("index is", index);
      let rowData = this.userForm.controls.users['controls'][index].value;
      if (field && field.hasOwnProperty('conversion') && field.conversion) {
        let conversion = field.conversion;
        if (conversion.component == "dropdown" || conversion.component == "searchselect" && conversion.hasOwnProperty('datasource')) {
          //options already available on the client, no need to call the datasource
          let localOptions: any = this.getMethodOptions(index);
          if (localOptions.length == 0 && conversion.datasource != undefined && conversion.datasource.possible_value) {
            localOptions = conversion.datasource.possible_value;
          }
          //nothing cached yet, fall back to the datasource
          if (localOptions != undefined && localOptions.length == 0) {
            localOptions = undefined;
          }
          if (conversion.component == "dropdown") {
            this.checkControlTypesAndInitiateForm(conversion.component, field, conversion, rowData, localOptions, index)
          }
          if (conversion.component == "searchselect") {
            this.checkControlTypesAndInitiateForm(conversion.component, field, conversion, rowData, localOptions, index)
          }
        }
      }
    } catch (error) {
      this.loader.hideSpinner();
    }

  }

  checkControlTypesAndInitiateForm(type, field, conversion, rowData, options?, index?) {
    if (type == "dropdown") {
      if (options != undefined) {
        this.applyDropdownConversion(field, conversion, rowData, options, index);
        return;
      }
      this.getOptions(conversion.datasource, rowData, (callBack) => {
        if (callBack) {
          this.applyDropdownConversion(field, conversion, rowData, callBack, index);
        }
      });
    }
    if (type == "searchselect") {
      field.datasource = conversion.datasource;
      field.component = conversion.component;
      field.controlType = conversion.component;
      field.value = rowData[field.key];
      field.dependents = conversion.dependents
      field.getterKey = conversion.getterKey
      field.getterValue = conversion.getterValue
      field.format = conversion.format
      field.required = conversion.required
      field.populate_field = conversion.populate_field
      field.defaultsetting = conversion.defaultsetting
      field.flag = conversion.flag
      field.popover = conversion.popover
      field.req_keys = conversion.req_keys
      this.loader.hideSpinner();
      this.initiateForm(this._editableGridData.nestedFields);
      this.cdRef.detectChanges();
      //this.loader.hideSpinner();
    }
  }

  getOptions(datasource, data, callBack) {
    let obj = {
      args: datasource.args ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : '',
      filter: datasource.filter ? this.baseService.buildDyanamicStr(datasource.args, { data: data }) : ''
    }
    this.baseService.getData(obj, '', datasource.resource, datasource.application, datasource.query_id).subscribe((d) => {
      if (d.errCode == 0 && d.resource && d.resource.length > 0) {
        callBack(d.resource);
      } else {
        callBack([]);
      }
    }, (err) => {
      console.error("err", err);
      callBack([]);
    })
  }

  getDefaultValue(field, index?) {
    if (this.isConversionAllowed(field, index)) {
      return 'Search';
    }
    return '';
  }

  // Hover hint so the user knows the cell can be edited (methodsEditable on the row)
  getConversionTooltip(field, index?) {
    if (this.isConversionAllowed(field, index)) {
      return 'Click to edit';
    }
    return null;
  }

  // Conversion is driven by the backend row, not the json: the same methodsEditable flag the result-entry screen uses
  isConversionAllowed(field, index?) {
    if (field == undefined || !field.conversion) {
      return false;
    }
    let rowItem = (this._editableGridData && this._editableGridData.items && index != undefined) ? this._editableGridData.items[index] : undefined;
    if (rowItem == undefined || rowItem.status == 'Final') { //a finalized row stays read only
      return false;
    }
    return rowItem.methodsEditable == true;
  }

  applyDropdownConversion(field, conversion, rowData, options, index?) {
    field.datasource = { ...(conversion.datasource || {}), possible_value: options };
    field.component = conversion.component;
    field.controlType = conversion.component;
    field.options = options;
    field.value = rowData[field.key];
    field.dependents = conversion.dependents;
    field.getterKey = conversion.getterKey;
    field.getterValue = conversion.getterValue;
    field.format = conversion.format;
    field.required = conversion.required;
    field.populate_field = conversion.populate_field;
    field.req_keys = conversion.req_keys;
    //initiateForm() rebuilds every row, the control of this row already exists so only that one is refreshed
    let control = index != undefined && this.getFormData.controls[index] != undefined ? this.getFormData.controls[index].get(field.key) : undefined;
    if (control != undefined) {
      control['question_component'] = { "question": field };
      if (field.required) {
        control.setValidators(Validators.required);
      }
      control.setValue(field.value, { emitEvent: false });
      control.updateValueAndValidity({ emitEvent: false });
    } else {
      this.initiateForm(this._editableGridData.nestedFields);
    }
    this.cdRef.detectChanges();
    this.loader.hideSpinner();
  }

  // Options for a method field: the row's own methods_list, else the cached method valueset
  getMethodOptions(index?) {
    let rowItem = (this._editableGridData && this._editableGridData.items && index != undefined) ? this._editableGridData.items[index] : undefined;
    let parsed = [];
    try {
      parsed = JSON.parse(sessionStorage.getItem('methodValueSet') || '[]');
    } catch (e) {
      parsed = [];
      console.log("Error in getting session method values : " + e);
    }
    let rawOptions = (rowItem && rowItem.methods_list && rowItem.methods_list.length) ? rowItem.methods_list : parsed;
    let valueSets = rawOptions.map(option => ({ ...option, display: option.display || option.text }));
    //the method already saved on the row may not be part of the list, keep it selectable
    if (rowItem != undefined && rowItem.methodsEditable == true && rowItem.method != undefined && rowItem.method !== ''
      && !valueSets.some(option => option.display == rowItem.method)) {
      valueSets.push({ display: rowItem.method, text: rowItem.method });
    }
    return valueSets;
  }

  getConversionClass(field, index?) {
    if (this.isConversionAllowed(field, index)) {
      return 'on-hover-edit';
    }
    return '';
  }

  setControls(resource) {
    this.initialiseForm();
    for (const currentRes of resource) {
      this.setDropdownVal(currentRes);
    }
  }

  setDropdownVal(resultVal) {
    if (resultVal?.free_text && resultVal.resultTypeDropDownValues) {
      if (resultVal.value) {
        resultVal.resultTypeDropDownValues.push({ id: resultVal.value, text: resultVal.value });
      }
      // for setting Add button for free_text services
      // 1. Remove all free_text first
      resultVal.resultTypeDropDownValues = resultVal.resultTypeDropDownValues.filter(item => item.id !== 'free_text');
      // 2. Add single free_text at end
      resultVal.resultTypeDropDownValues.push({ id:'free_text', text:"Add (+)" });
    }
    return resultVal;
  }
  validateComparisonSymbols(evt): boolean {
    const key = evt.key;
    const value = evt.target.value;
    if (key === "<" || key === ">") {
      if (value.length > 0) {
        return false;
      }
      if (value.includes("<") || value.includes(">")) {
        return false;
      }
    }
    if (key === "=") {
      const cursorPos = evt.target.selectionStart;
      if (cursorPos !== 1 || !("<>".includes(value.charAt(0)))) {
        return false;
      }
    }
    return true;
  }

  validateAllowedCharacters(evt): boolean {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode != 58 || (charCode == 58 && evt.target.value.includes(":"))) && charCode != 45 && charCode != 46 && charCode != 60 && charCode != 61 && charCode != 62 && charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validateDuplicateCharacter(lastEnteredCode, evt): boolean {
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (lastEnteredCode == charCode) {
      return false;
    }
    return true;
  }

  isNumberKey(evt, result) {
    let lastEnteredCode;
    if (evt.valueOf().key === "." || evt.valueOf().key === "-") {
      lastEnteredCode = result.value ? result.value.substring(evt.target.value.length - 1).charCodeAt() : undefined;
    }
    if (!this.validateComparisonSymbols(evt)) {
      return false;
    }
    if (!this.validateAllowedCharacters(evt)) {
      return false;
    }
    if (!this.validateDuplicateCharacter(lastEnteredCode, evt)) {
      return false;
    }
    return true;
  }


  async onAllChecked(event) {
    console.log("On All Checked " + event);
    let items = [];
    this._editableGridData.items.forEach((item, index) => {
      item['index'] = index;
      if (this.settings.selectall) {
        this.selectedIndices[index] = event;
        if (event) {
          items.push(item);
        }
      }
    });
    this.selectedItems = items;
    this.form.value.tests = this.selectedItems;
    this.form.controls.tests.setValue(this.selectedItems);
    this.value = items;

  }

  async onSingleItemchecked(event) {
    console.log("On Single Itemchecked " + event);
    let items = [];
    this._editableGridData.items.forEach((item, index) => {
      item['index'] = index;
      if (this.settings.all_selected_condition) {
        let checked_ = eval(this.settings.all_selected_condition.expression);
        if (checked_) {
          this.selectedIndices[index] = true;
          items.push(item);
          if (item.resultType && item.resultType == "numeric") {
            this.indicatorChange(item.value, this.getFormData.controls[index], index);
          }
        } else {
          this.selectedIndices[index] = false;
        }
      }
    });
    this.selectedItems = items;
    this.form.value.tests = this.selectedItems;
    this.form.controls.tests.setValue(this.selectedItems);
    this.value = items;

  }

  onItemChecked(check, index) {
    this.selectedIndices[index] = check;
    this.selectedItems = [];
    for (let d = 0; d < this.selectedIndices.length; d++) {
      if (this.selectedIndices[d]) {
        this.userForm.controls.users['controls'][d].value['index'] = d;
        let val = this.userForm.controls.users['controls'][d].value;
        let rawVal = this.userForm.controls.users['controls'][d].getRawValue();
        //merging form value and rawvalue as we have set index in value which don't contains the value of disabled attributes 
        let resultObj = { ...val, ...rawVal };
        this._editableGridData.items.map(x => x.id == rawVal.id ? x.value = rawVal.value : x.value = x.value);
        this.selectedItems.push(resultObj);
      }
    }
    this.form.value.tests = this.selectedItems;
    this.form.controls.tests.setValue(this.selectedItems);
    this.value = this.selectedItems; //added as it will set value to the 


  }

  get getFormData(): FormArray {
    return <FormArray>this.userForm.get('users');
  }



  save() {
    console.log('isValid', this.userForm.valid);
    console.log('value', this.userForm.value);
  }


  displayFilter() {
    this._editableGridData.filter = !this._editableGridData.filter;
    this.searchConfig['filterOpenStatus'] = this._editableGridData.filter;
  }

  markChecked(event, i, ctrl?) {
    console.log('Key press value', event);
    if (ctrl && ctrl.value && ctrl.value.resultType == 'numeric') {
      this.indicatorChange(ctrl.value.value, ctrl, i);
    }
    if (event.target && event.target.value != undefined && event.target.value != '') {
      this.onItemChecked(true, i);
    } else if (event.value && event.value.value != undefined && event.value.value != '') {
      this.onItemChecked(true, i);
    } else if (event && event.val != undefined && event.val != '') {
      this.onItemChecked(true, i);
    } else {
      this.onItemChecked(false, i);
    }
    if (this.userForm?.controls?.users && this.userForm.controls.users?.value[i] && this.userForm.controls.users.value[i].resultType == 'dropdown') {   // for dropdown resultType 
      const item = this.userForm.controls.users.value[i];

      // free text support (service based)
      if (item.free_text && event?.target?.value == "free_text") {
        this.setValueOfDropdown(item, i);
      }

      // for criticalValue color coding
      if (item.criticalValue) {
        const inputs = document.getElementById('resultType_' + i);
        const serviceItemLabels = document.getElementById('serviceItemName_' + i);
        if (item.criticalValue && item.value && item.criticalValue === item.value) {
          this.setColor(inputs, serviceItemLabels);
          this.setResultCritical(i, true);
        } else {
          inputs?.classList.remove("showFontColor");
          serviceItemLabels?.classList.remove("showFontColor");
          this.setResultCritical(i, false);
        }
      }
    }
    if (ctrl != undefined && ctrl && this.form.value.autoCalculationOn)
      this.bulkformulaCalculation(this.userForm, ctrl.value, i);   // for auto-calculation of formula
  }

  setValueOfDropdown(record, id) {
    if (record) {
      const formRecord = this.userForm.value.users[id];
      let obj = {
        data: formRecord?.resultTypeDropDownValues,
        resource: "specimen_additional_dropdown",
        action: "ADD",
        layout_type: "simple",
        getdata: true,
        customButton: {
          "Add": [
            {
              "label": "Submit"
            }
          ]
        }
      };
      this.smartModalService.open(PopupFormComponent, obj, "Add Text", ModalSize.Sm).subscribe(res => {
        if (res && res.result && res.result.result) {
          let output = res.result.result?.additional_value;
          if (!output) return;
          const editGridData = this._editableGridData.items[id];
          const formArray = this.userForm.get('users') as FormArray;
          const control = formArray.at(id);

          // record.resultTypeDropDownValues = record.resultTypeDropDownValues.filter(x => x.id !== 'free_text');
          const filtered = record.resultTypeDropDownValues.filter(x => x.id !== 'free_text');
          
          const newOption = { id: output, text: output };

          filtered.push(newOption);
          filtered.push({ id: 'free_text', text: 'Add (+)' });

          record.resultTypeDropDownValues = [...record.resultTypeDropDownValues];

          // sync editable grid
          editGridData.value = output;
          this.selectedItems[id].value = output;
          editGridData.resultTypeDropDownValues = [...record.resultTypeDropDownValues];

          control.get('resultTypeDropDownValues')?.setValue(filtered);
          control.get('value')?.setValue(newOption.id);
          
          // record.resultTypeDropDownValues[lastIndex] = { id: output, text: output };

          // this.userForm.controls.users.value[id].value = output;

          // // for adding new value
          // record.resultTypeDropDownValues.push({ id: 'free_text', text: "Add (+)" });
        }
      }, err => {
        console.log("error : " + err);
      });
    }
  }

  secondMarkChecked(event, i, ctrl?) {
    console.log('Key press value', event);
    if (ctrl && ctrl.value && ctrl.value.resultType == 'numeric') {
      this.indicatorChange(ctrl.value.value, ctrl, i);
    } else if (event.value && event.value.value != undefined && event.value.value != '') {
      this.onItemChecked(true, i);
    }
  }

  convertSymbolicValue(value: any): any {
  if (typeof value !== 'string') {
    return value;
  }
  value = value.trim();
  const validPattern =  /^(<=|>=|<|>)?-?\d+(\.\d+)?$/;
  if (!validPattern.test(value)) {
    return value;  
  }
  let symbol = "";
  const match = value.match(/^(<=|>=|<|>)?/);
  if (match && match[0]) {
    symbol = match[0];
  }
  const numberPart = value.replace(/^(<=|>=|<|>)/, "");
  let numericValue = parseFloat(numberPart);
  switch (symbol) {
    case "<":
      numericValue = (numericValue % 1 !== 0)? Math.floor(numericValue) : numericValue - 1;
      break;
    case ">":
      numericValue = (numericValue % 1 !== 0)? Math.ceil(numericValue): numericValue + 1;
      break;
    case "<=":
    case ">=":
    default:
      break;
  }

  return numericValue;
}

  indicatorChange(val, form, index) {
  try {

     const compareVal = this.convertSymbolicValue(val);
    if (form.controls.referenceRange.value) {

      let low = form.controls.referenceRange.value.low;
      let high = form.controls.referenceRange.value.high;
      let minPanicValue = form.controls.referenceRange.value.minPanicValue;
      let maxPanicValue = form.controls.referenceRange.value.maxPanicValue;
      const skipCritical = !!form.controls.referenceRange.value?.dontNeedCriticalValues;
      if (!skipCritical && form.controls.value.referenceRange != "" && (high || low)) {

        if (
          (compareVal < high && compareVal > low) ||
          (compareVal == high || compareVal == low) ||
          ((compareVal < high && low == undefined) ||
           (compareVal > low && high == undefined)) ||
          compareVal == ""
        ) {

          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question.value = "";
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("");
          this.userForm.controls.users['controls'][index].controls.isResultCritical.question_component.question.value = false;
          this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(false);

          this._editableGridData.items[index]['abnormalValueInterpretation'] = "";
          this._editableGridData.items[index]['isResultCritical'] = false;
        }

        // Critical High
        else if (
          maxPanicValue != undefined &&
          compareVal > maxPanicValue
        ) {

          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question.value = "H";
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("H");
          this.userForm.controls.users['controls'][index].controls.isResultCritical.question_component.question.value = true;
          this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(true);

          this._editableGridData.items[index]['abnormalValueInterpretation'] = "H";
          this._editableGridData.items[index]['isResultCritical'] = true;
        }

        // Critical Low
        else if (
          minPanicValue != undefined &&
          compareVal < minPanicValue
        ) {

          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question.value = "L";
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("L");
          this.userForm.controls.users['controls'][index].controls.isResultCritical.question_component.question.value = true;
          this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(true);

          this._editableGridData.items[index]['abnormalValueInterpretation'] = "L";
          this._editableGridData.items[index]['isResultCritical'] = true;
        }

        // Low
        else if (compareVal < low) {

          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question.value = "L";
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("L");
          this.userForm.controls.users['controls'][index].controls.isResultCritical.question_component.question.value = false;
          this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(false);

          this._editableGridData.items[index]['abnormalValueInterpretation'] = "L";
          this._editableGridData.items[index]['isResultCritical'] = false;
        }

        // High
        else if (compareVal > high) {

          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question.value = "H";
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("H");
          this.userForm.controls.users['controls'][index].controls.isResultCritical.question_component.question.value = false;
          this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(false);

          this._editableGridData.items[index]['abnormalValueInterpretation'] = "H";
          this._editableGridData.items[index]['isResultCritical'] = false;
        }

        this.getFormattedValue(
          index,
          this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.question_component.question,
          this._editableGridData.items[index]
        );
      }

      // for setting numeric results font color as abnormal values
      setTimeout(() => {
        if (this._editableGridData.items.length == this.eg_grid_data.length) {
          const inputs = document.getElementById('resultType_' + index);
          const serviceItemLabels = document.getElementById('serviceItemName_' + index);

          if (
            inputs &&
            serviceItemLabels &&
            this._editableGridData.items[index]['abnormalValueInterpretation']
          ) {
            inputs.classList.add("showFontColor");
            serviceItemLabels.classList.add("showFontColor");
          } else {
            inputs?.classList.remove("showFontColor");
            serviceItemLabels?.classList.remove("showFontColor");
          }
        }
      }, 500);
    }
  } catch (error) {
    console.log("Inside Indicator Changes: ", error);
  }
}
  // for changing sequencing of grid for blood-bank orders
  getBloodBankOrders(event) {
    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.listBlocks.APIresource.filter, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : undefined);
  }

  getResourceDef(name) {
    this.baseService.getResourceDef(name, json_val => {
      if (json_val) {
        this.data['fields'] = json_val.list.fields;
        this.searchConfig.complex_search = json_val.list.complex_search;
        this._editableGridData.filter_block = json_val.list.filter ? json_val.list.filter : null;
        this._editableGridData.listBlocks = json_val.list;
        this.settings = json_val.settings;
        this.config = json_val.config;
        this._editableGridData['capability'] = json_val.capability;
        this._currentData['json'] = json_val.resource;
        this._editableGridData['resource'] = json_val.resource;
        if (json_val.config) {
          this._editableGridData.noCount = json_val.config.noCount ? true : false;
        }
        // if (json_val.settings.hasOwnProperty('defualt_page_size')) {
        this._editableGridData.page_size = 50;
        this._editableGridData.page_limit = [10, 20, 50, 100, 250, 500];
        // }

        // for checking auto-calculation config
        this.checkAutoCalculationConfig();

        this.fetchData(json_val.list.APIresource.datasource);
        if (this._editableGridData['tableInitalized']) {
          this._editableGridData['tableInitalized'] = false;
        }
      }
      // decorator implementation
      this.config.decorator = this.baseService.initDecorator(this.config.decorator, this.route, this.injector);

      //getting saved filters
      this.getSavedFilter();

    });
  }

  getDropdownList(list, cb) {
    this.baseService.get("GET_ALL", "", "dropdownMasterValueMapping", "diagnostic", "dropdownMasterName:" + list.dropdown_list).subscribe((data) => {
      if (data && data.resource.length > 0) {
        cb(data.resource);
      }
      else {
        cb([]);
      }
    });
  }

  removeFilters(data) {
    try {
      if (data != undefined && data['filter__'] != undefined && data['filter__'].length != undefined && data['filter__'].length > 0) {
        for (let i = 0; i < data['filter__'].length;) {
          let item = data['filter__'][i];
          if (this.rolePermissionService.checkAccessPermission('user_group_filter', 'user_group_filter', 'account-management') && (this.appService.getOrganization() && this.appService.getOrganization().org_id != undefined && item.facility_id != undefined && (this.appService.getOrganization().org_id == item.facility_id))) {
            i = i + 1;
          }
          else if (item.userGroupId != undefined && item.userGroupId && (item.userGroupId != this.appService._currentSessionData.user_group)) {
            data['filter__'].splice(i, 1);
          }
          else {
            i = i + 1;
          }
        }
      }
    } catch (error) {

    }

  }

  getSavedFilter(callback: any = false) {
    console.log("Config", this.config);
    this.getTableConfig((data) => {
      console.log("Quick Filters ", this.filterFieldGroup);
      //getting account 
      if (data) {
        //removing filters 
        // this.removeFilters(data);

        if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] != undefined) {
          this.filterFieldGroup.quick_filters.forEach(function (item) {
            item['type'] = 'quick';
          });
          this.config.filterAr = this.filterFieldGroup.quick_filters.concat(data['filter__']);
          if (callback) {
            callback(this.config.filterAr);
          }
        } else if (this.filterFieldGroup && this.filterFieldGroup.quick_filters && data['filter__'] == undefined) {
          this.filterFieldGroup.quick_filters.forEach(function (item) {
            item['type'] = 'quick';
          });
          this.config.filterAr = this.filterFieldGroup.quick_filters;
          if (callback) {
            callback(this.config.filterAr);
          }
        } else
          if (data['filter__'] != undefined && data['filter__'].length) {
            this.config.filterAr = data['filter__'];
            if (callback) {
              callback(data['filter__']);
            }
          }
          else if (data[this.searchConfig.saveKey] != undefined && data[this.searchConfig.saveKey]['filter__'] != undefined && data[this.searchConfig.saveKey]['filter__'].length) {
            this.config.filterAr = data[this.searchConfig.saveKey]['filter__'];
            this.config.localStorageData = { filter__: data[this.searchConfig.saveKey]['filter__'] }
            if (callback) {
              callback(data[this.searchConfig.saveKey]['filter__']);
            }
          } else {
            this.config.filterAr = [];
            if (callback) {
              callback([]);
            }
          }
      }
    });
  }

  getAccountLevelFilters(data, cb) {
    try {
      this.getAllTableConfig((allData_) => {
        if (allData_["account__" + this.config.saveKey] != undefined) {
          var data_ = allData_["account__" + this.config.saveKey];
          if (data.filter__ != undefined && data.filter__.length != undefined && data_.filter__ != undefined && data_.filter__.length != undefined) {
            data.filter__ = [...data.filter__, ...data_.filter__];
          }
          else if (!data.filter__) {
            data['filter__'] = data_.filter__;
          }
        }
        cb(true);
      });
    } catch (error) {
      cb(true);
    }

  }

  getAllTableConfig(callback, account?) {
    var key = this.config.saveKey;
    //if account is true then we will not load the cached data
    this.preferenceService.getUserPreferenceConfig([key], (data) => {
      callback(data);
    });
  }

  getTableConfig(callback, account?) {
    var key = this.searchConfig.saveKey;
    //if account is true then we will not load the cached data
    this.preferenceService.getUserPreferenceConfig(key, (data) => {
      if (!account) {
        this.config.localStorageData = data;
      }
      callback(data);
    }, account);
  }
  get value() {
    return this.userForm.value.users.value;
  }

  set value(val) {
    this.userForm.value.users.value = val;
    this.propagateChange(val);
  }

  //***********************************Get data from DB based on Datasource **************************************/
  async fetchData(datasource, filterStr_?, searchStr_?, sortObj?) { // Get Data from API funtion
    this._editableGridData.isDataLoading = true;
    this._currentData.loadSavedFilter = true;
    let searchStr = searchStr_;
    let filterStr = filterStr_;
    if (searchStr_ == undefined) {
      searchStr = {};
      this.updateCurrentDataFromSavedFilter(searchStr);
      if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData['filter'] != undefined && this._currentData.gridData['filter'] && (filterStr_ == undefined)) {
        this.searchConfig['filterLabel'] = this._currentData.filterPrintInfo;
        filterStr = this._currentData.gridData['filter'];
        this._editableGridData.existingFilter = filterStr;
      }
      if (this._currentData.page_no != undefined) {
        this._editableGridData.page_no = JSON.parse(JSON.stringify(this._currentData.page_no));
        delete this._currentData['page_no'];
      }
      if (this._currentData.page_size != undefined) {
        this._editableGridData.page_size = JSON.parse(JSON.stringify(this._currentData.page_size));
        delete this._currentData['page_size'];
      }
    }
    let search = '';
    let search_columns: any;
    // let sortObj_ = sortObj;
    if (typeof searchStr == 'object') {
      if (searchStr.key != undefined && searchStr.value != undefined) {
        search_columns = [searchStr.key];
        search = searchStr.value;
      }

    } else {
      search = searchStr;
    }
    this.loader.showSpinner();
    if (this.Router.url.includes("bulkresultEntry")) {
      this.checkProvisionalConfig((cb) => {
        if (cb) {
          this.form.controls.isProvisional.setValue(true);
        } else {
          this.form.controls.isProvisional.setValue(false);
        }
      });
    }
    if (datasource != undefined) {
      datasource = JSON.parse(JSON.stringify(datasource));
      var data_ = JSON.parse(sessionStorage.getItem('currentData')) != undefined && JSON.parse(sessionStorage.getItem('currentData')) ? JSON.parse(sessionStorage.getItem('currentData')) : {};
      //Merging formcontrol in data_ if available in this._editableGridData
      if (this._editableGridData.hasOwnProperty('form_controls')) {
        data_ = { ...data_, ...this._editableGridData['form_controls'] }
      }
      //Reading data from snapshot to make params
      if (this.route && this.route.snapshot.params && typeof this.route.snapshot.params == "object") {
        data_ = { ...data_, ...this.route.snapshot.params };
      }
      this._editableGridData.args_filter = data_;
      //binding dynamic args
      datasource.args = datasource.args != undefined ? this.baseService.buildDyanamicStr(datasource.args, { data: data_ }) : '';
      //binding dynamic filters
      datasource.filter = datasource.filter != undefined ? this.baseService.buildDyanamicStr(datasource.filter, { data: data_ }) : '';
      if (this._editableGridData.noCount) {
        if (datasource.args) {
          datasource.args += ",noCount:1"
        } else {
          datasource.args += "noCount:1"
        }
      }
      if (this.bloodBankOrdersToggle != undefined && this.bloodBankOrdersToggle) {
        datasource.args += ",blood_bank_orders:true";
        this.dataIndex = 0;
        this.eg_grid_data = [];
      } else {
        datasource.args += ",blood_bank_orders:false";
        this.dataIndex = 0;
        this.eg_grid_data = [];
      }
      var params = {
        args: datasource.args,
        filter: datasource.filter ? (filterStr ? (filterStr + ',' + datasource.filter) : datasource.filter) : (filterStr ? filterStr : ''),
        page_no: this._editableGridData.page_no || 0,
        page_size: this._editableGridData.page_size,
        search_columns: search_columns ? search_columns : '',
        search: search ? search : "",
        order_by: datasource.order_by != undefined && datasource.order_by ? datasource.order_by : ''
      }
      if (params.page_no == 0) {
        delete params.page_no
      }
      if (sortObj != undefined && sortObj) {
        params['order_by'] = sortObj.key + " " + sortObj.value;

      }
      //added to support exact search
      if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
        //do nothing
      }
      else {
        if (searchStr_ != undefined && searchStr_.searchObj != undefined && searchStr_.searchObj.eq_search != undefined) {
          params['eq_search'] = 'y';
        } else if (this._currentData != undefined && this._currentData.gridData != undefined && this._currentData.gridData.eq_search != undefined) {
          params['eq_search'] = this._currentData.gridData.eq_search;
        } else if (search != undefined && search != "" && this.searchConfig != undefined && this.searchConfig.eq_search != undefined && this.searchConfig.eq_search != "") {
          params['eq_search'] = this.searchConfig.eq_search;
        }
      }


      //setting code for persistance 
      try {

        if (this._currentData.saveFilterKey != undefined && this.persistGrid()) {
          delete this._currentData.saveFilterKey;
          this.saveFilterObj({ gridData: params }, (responseConfig) => {
            var queryObj = {};
            queryObj[responseConfig["filterSaveKey"]] = responseConfig["filterKey"];

            var url = this.Router.createUrlTree([], { relativeTo: this.route, queryParams: queryObj, queryParamsHandling: 'merge' }).toString()
            this.locationCommon.replaceState(url);

            //this.router.onSameUrlNavigation = 'ignore';
            this.Router.navigate(['.'], { relativeTo: this.route, queryParams: queryObj, replaceUrl: true, queryParamsHandling: 'merge' });//maintain history so that user could go back (uncommenting because router params was not updating)
          });
        }
        //  else{
        //    this.resetFilterKey();
        //  }
      } catch (e) {
        console.log(e);
        // this._currentData.resouceDef.resource
      }
      //persistance end

      params.filter = this.filterService.removeDuplicateKeysFromString(params);  // Removing duplicate keys from filter
      // if (this.baseService.validateParams(datasource.args) && this.baseService.validateParams(datasource.filter)){
      console.log("params are :; ", params, " datasource.resource ", datasource.resource);
      await this.baseService.getData(params, "", datasource.resource, datasource.application, datasource.query_id).toPromise().then(
        (data: any) => {
          // this._editableGridData.resourceData = data;
          this._editableGridData.isDataLoading = false;
          if (data.errCode == -1) {
            this.bloodBankOrdersToggle = false;
            this.loader.hideSpinner();
            // TODO
            this.alerts.error(data.message);
            this._editableGridData['show_'] = false;
          } else if (data.errCode == 0 && data.hasOwnProperty('resource')) {
            //initializsing it here as in getFormControls items are null thus checkbox was not working properly
            this._editableGridData.selectedCount = 0;
            this._editableGridData.items = [];
            this.selectedIndices = [];
            console.log("params", params);
            if (this._editableGridData.noCount) {
              this._editableGridData.itemsCount = -1;
            } else {
              this._editableGridData.itemsCount = data.count;
            }
            this._editableGridData.currentItemCount = data.resource.length;

            this._editableGridData.items = data.resource;
            this.setControls(data.resource);
            this.initiateForm();
            if (this.settings.all_selected) {
              setTimeout(() => {
                if (this.userForm.value.users.length > 0) {
                  for (let item of this.userForm.value.users) {
                    if (this.settings.all_selected_condition && eval(this.settings.all_selected_condition.expression)) {
                      this.selectedItems.push(item);
                    }
                    if (!this.settings.all_selected_condition)
                      this.selectedItems.push(item);
                  }
                  if (!this.settings.all_selected_condition)
                    this.onAllChecked(true);
                  if (this.settings.all_selected_condition)
                    this.onSingleItemchecked(true);
                }
              });
            }
            this.loader.hideSpinner();

            // this.setdropdown(data.resource, (cb) => {
            //   if (cb) {

            //   }
            // });
          }
          this._editableGridData.filter = false;
        }, error => {
          console.log(error);
        }
      )
      //}
    }
  }

  // not in use because resultTypeDropDownValues has the dropdown data from 2023
  setdropdown(data, cb) {
    try {
      this.loader.showSpinner();
      const responseData = [];
      const dropdownVal = [];
      for (let item of data) {
        if (item.resultType == 'dropdown' && !item.resultTypeDropDownValues) {
          const observable = this.baseService.get("GET_ALL", "", "dropdownMasterValueMapping", "diagnostic", "dropdownMasterName:" + item.dropdown_list);
          dropdownVal.push(item);
          responseData.push(observable);
        }
      }

      if (dropdownVal.length == 0) {
        cb(true);
      }

      forkJoin(responseData).subscribe(
        (responses) => {
          // Do something with the responses
          console.log(responses);
          for (let i = 0; i < dropdownVal.length; i++) {
            if (dropdownVal[i].resultType == 'dropdown') {
              let itemData = responses[i] != undefined && responses[i]['resource'] != undefined && responses[i]['resource'].length != undefined && responses[i]['resource'].length > 0 && responses[i]['resource'][0].dropdownValueMaster != undefined ? responses[i]['resource'][0].dropdownValueMaster : [];
              dropdownVal[i]['resultTypeDropDownValues'] = itemData;
            }
          }
          cb(true);
        },
        (error) => {
          // Handle errors
          console.error(error);
        }
      );

    } catch (error) {
      cb(true);
    }
  }

  updateCurrentDataFromSavedFilter(searchStr) {
    if (this._currentData.loadSavedFilter != undefined) {
      this._currentData.gridData = {};
      var filterSavedObj = this.getFilterLabel();
      if (filterSavedObj && filterSavedObj["filter"] != undefined) {
        this._currentData.gridData['filter'] = filterSavedObj["filter"];//apply filter which is in url
      }
      if (filterSavedObj && filterSavedObj["filterLabel"] != undefined && this._currentData != undefined && this._currentData.filterPrintInfo == undefined) {
        this._currentData.filterPrintInfo = filterSavedObj["filterLabel"];//apply filter which is in url
      }

      if (this._currentData && this._currentData["filterName"] != undefined) {
        this.config.filterConfig["FilterName"] = this._currentData.filterName ? this._currentData.filterName : filterSavedObj["filterName"];
      } else {
        if (filterSavedObj && filterSavedObj["filterName"] != undefined && this.config.filterConfig == undefined) {
          this.config["filterConfig"] = {};
          this.config.filterConfig["FilterName"] = filterSavedObj["filterName"];
        }
      }

      if (filterSavedObj && filterSavedObj["search_columns"] != undefined) {
        searchStr['key'] = filterSavedObj["search_columns"][0];//apply filter which is in url
        this.searchConfig.searchColumns = searchStr['key'];
      }

      if (filterSavedObj && filterSavedObj["search"] != undefined) {
        searchStr['value'] = filterSavedObj["search"];//apply filter which is in url
        this.searchConfig.search = searchStr['value'];
      }

      if (filterSavedObj && filterSavedObj["searchColumns"] != undefined) {
        this._currentData.gridData['searchColumns'] = filterSavedObj["searchColumns"];//apply filter which is in url

      }
      if (filterSavedObj && filterSavedObj["searchLabel"] != undefined) {
        this._currentData.gridData['searchLabel'] = filterSavedObj["searchLabel"];//apply filter which is in url
      }
      if (filterSavedObj && filterSavedObj["noRule"] != undefined && filterSavedObj["noRule"] != undefined) {
        this._currentData.gridData['noRule'] = filterSavedObj["noRule"];//apply filter which is in url
      }
      if (filterSavedObj['page_size'] != undefined && !this._currentData['stopPageUpdate']) {
        this._currentData.page_size = filterSavedObj["page_size"];
      }
      if (filterSavedObj['page_no'] != undefined && !this._currentData['stopPageUpdate']) {
        this._currentData.page_no = filterSavedObj["page_no"];
      }
      if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
        //do nothing
      }
      else if (filterSavedObj && filterSavedObj['eq_search'] != undefined) {
        this.searchConfig.eq_search = filterSavedObj["eq_search"];
      }

      //var filterSaveKey = "f__k";
      // delete this._currentData.saveFilterKey;
      delete this._currentData.loadSavedFilter;
      /********TODO PRININFO IMPLEMENT ON PRINT FROM SAVED FILTER *******/
      //this.storageService.removeSesssionData(filterSaveKey+"_"+this._currentData.resouceDef.resource);

      // For clearing filter Data from session after clicking on tab to reset grid to initial filter
      if (!filterSavedObj && this._currentData && !this._currentData.filterPrintInfo) {
        try {
          let res = this._currentData != undefined && this._currentData.json != undefined ? this._currentData.json : '';
          this.storageService.removeSesssionData('f__k' + "_eg" + this._currentData.json);
          this.storageService.removeData('filterConfig' + res, () => { });
          this.storageService.removeData('filterName' + res, () => { });
          this.storageService.removeData('filterFormMapping' + res, () => { });
        } catch (error) {

        }
      }
    }
  }


  getFilterLabel() {
    console.log("========getFilterLabel===============");
    if (this.persistGrid()) {
      try {
        var snapshot = this.route.snapshot;
        var filterSaveKey = "f__k";
        var params = { ...snapshot.queryParams };
        if (params[filterSaveKey] != undefined && params[filterSaveKey]) {
          var filterObj = this.storageService.getSessionStorageDataSync(filterSaveKey + "_eg" + this._currentData.json);
          if (filterObj) {
            if (filterObj["key"] != undefined && filterObj["key"] == params[filterSaveKey]) {
              return filterObj;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    } else {
      return false;
    }

  }

  persistGrid() {
    if (this._currentData.origArhiveConfig != undefined) {
      return false;
    }
    if (this._currentData && this._currentData["archiveConfig"] != undefined && this._currentData["archiveConfig"]["applied"] != undefined && this._currentData["archiveConfig"]["applied"]) {
      return false;
    }
    return (this.constructor.name.toLowerCase() == "bulkentrymaincomponent");
  }

  saveFilterObj(config, callback) {
    var filterSaveKey = "f__k";
    var gridData;
    var filterKey = this.baseService.generateID(5);
    var filterObj = { key: filterKey };
    var savedObj = this.getFilterLabel();

    if (savedObj && savedObj["key"] != undefined) {
      filterObj["key"] = savedObj["key"]; //we found already saved filter whose key is present in url bar
    }

    if (config["gridData"] != undefined) {
      gridData = config["gridData"];
      if (gridData['filter'] != undefined && gridData['filter']) {

        if (gridData['filter'] != undefined) {
          filterObj["filter"] = gridData['filter'];
        }

        if (this._currentData.filterPrintInfo != undefined) {
          filterObj["filterLabel"] = this._currentData.filterPrintInfo;
        }

      }

      if (gridData && gridData["search_columns"] != undefined) {
        filterObj["search_columns"] = gridData["search_columns"];
      }

      if (gridData && gridData["search"] != undefined) {
        filterObj["search"] = gridData["search"];
      }
      if (gridData && gridData["searchLabel"] != undefined) {
        filterObj["searchLabel"] = gridData["searchLabel"];
      }

      if (gridData && gridData["searchColumns"] != undefined) {
        filterObj["searchColumns"] = gridData["searchColumns"];
      }
      if (gridData && gridData["noRule"] != undefined) {
        filterObj["noRule"] = gridData["noRule"];
      }
      if (gridData && gridData["page_size"]) {
        filterObj['page_size'] = gridData["page_size"];
      }
      if (gridData && gridData["page_no"] != undefined) {
        filterObj['page_no'] = gridData["page_no"] != undefined ? gridData["page_no"] : 0;
      }
      if (this._currentData != undefined && this._currentData.filterName != undefined) {
        filterObj["filterName"] = this._currentData.filterName;
      }
      if (this.appService.getAccountConfig() && this.appService.getAccountConfig().regex_search != undefined && this.appService.getAccountConfig().regex_search == true) {
        //do nothing
      }
      else if (gridData && gridData["eq_search"] != undefined) {
        filterObj["eq_search"] = gridData["eq_search"];
      }

      this.storageService.setSessionStorageData(filterSaveKey + "_eg" + this._currentData['json'], filterObj, () => {
        callback({ filterSaveKey: filterSaveKey, filterKey: filterObj["key"] });
      });
    }

    return false;


  }

  filterClick(event) {
    this.sortObject = false;
    this.currentSort.clear();
    this._currentData.saveFilterKey = true;
    let filter = "";
    if (this._editableGridData && this._editableGridData.existingFilter) {
      filter = this._editableGridData.existingFilter;
    }
    this.dataIndex = 0;
    this.eg_grid_data = [];
    //setting page no to zero as this should be on first page
    this._editableGridData.page_no = 0;
    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, filter ? filter : "", event);
    this._editableGridData.exsitingComplexSearch = event;
  }


  doSearch(filterStr) {

    this.sortObject = false;
    this.currentSort.clear();
    if (this.kxFilter != undefined && this.kxFilter && this.filterFormGroup != undefined && this.filterFormGroup && this.filterFormGroup.value != undefined) {
      this.kxFilter['filterVal'] = this.filterFormGroup.value;
      this.kxFilter['config']['quickFilter'] = false;
    }
    this.setFilterprintInfo((fitlerPrintInfo) => {
      if (fitlerPrintInfo)
        console.log("fitlerPrintInfo :: " + fitlerPrintInfo + this.kxFilter);
    });
    //this._editableGridData.listBlocks.APIresource.datasource['filter'] = filter + "," + this._editableGridData.listBlocks.APIresource.datasource['filter'];
    ///this._editableGridData.listBlocks.APIresource.datasource['filter'] = this.filterService.removeDuplicateKeysFromString(this._editableGridData.listBlocks.APIresource.datasource);
    //resetting pageno to initial level
    setTimeout(() => {
      this.dataIndex = 0;
      this.eg_grid_data = [];
      if (this._editableGridData != undefined && this._editableGridData.page_no != undefined) {
        this._editableGridData.page_no = 0;
      }
      this._editableGridData.existingFilter = filterStr;
      this._currentData.saveFilterKey = true;
      // this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, filterStr);
      this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, filterStr, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : undefined);
    });

  }

  setFilterprintInfo(callback) {
    let filterInfo: any = {};
    //this works to set value of filters
    if (this.kxFilter != undefined && this.kxFilter['form'] != undefined && this.kxFilter['form'].form != undefined && this.kxFilter['form'].form.controls != undefined) {
      let controls = this.kxFilter['form'].form.controls;
      Object.keys(controls).forEach(key => {
        //check condition
        let condition_ = controls[key] != undefined && controls[key] && controls[key].value != undefined && controls[key].value && controls[key].question_component != undefined && controls[key].question_component.question != undefined && controls[key].question_component.question.visible != undefined && controls[key].question_component.question.visible && this.kxFilter['filterVal'] != undefined && this.kxFilter['filterVal'] && get_(this.kxFilter['filterVal'], key) ? true : false;

        if (controls[key].question_component == undefined) {
          return;
        }
        let question = controls[key].question_component.question;

        //this case works for singelselect
        if (condition_ && (controls[key].question_component.question.controlType === "dropdown" || (controls[key].question_component.question.controlType === "searchselect" && controls[key].question_component.question.defaultsetting != undefined && controls[key].question_component.question.defaultsetting.singleSelection != undefined && controls[key].question_component.question.defaultsetting.singleSelection)) && question != undefined && question.options != undefined && question.options.length != undefined) {
          let currentOption = question.options.find(x => x[question.getterKey] === get_(this.kxFilter['filterVal'], key));
          if (currentOption) {
            this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
              let key_ = res;
              filterInfo[key_] = currentOption[question.getterValue];
              callback(filterInfo);
            })
          }
        }

        //this works in case of multiselect
        else if (condition_ && controls[key].question_component.question.controlType == "searchselect" && Array.isArray(get_(this.kxFilter['filterVal'], key)) && get_(this.kxFilter['filterVal'], key).length != undefined && get_(this.kxFilter['filterVal'], key).length > 0) {
          this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
            let val = JSON.parse(JSON.stringify(get_(this.kxFilter['filterVal'], key)));
            let val_ = val.map(e => e.text).join(",");
            let key_ = res;
            filterInfo[key_] = val_;
            callback(filterInfo);
          })
        }
        //all other cases
        else if (condition_ && controls[key].question_component.question.controlType != "hidden" && controls[key].question_component.question.controlType != "monthYearPicker" && controls[key].question_component.question.controlType != "daterangepicker" && controls[key].question_component.question.controlType != "searchselect" && controls[key].question_component.question.controlType != "dropdown") {
          this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
            let key_ = res;
            filterInfo[key_] = get_(this.kxFilter['filterVal'], key);
            callback(filterInfo);
          })
        }
        else if (condition_ && controls[key].question_component.question.controlType === "daterangepicker") {
          this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
            let key_ = res;
            let val = get_(this.kxFilter['filterVal'], key);
            if (val && val.FROM != undefined && val.FROM && val.TO != undefined && val.TO && !controls[key].question_component.question.singleDatePicker) {
              let modVal = this.utilService.toTimeZoneDateFormat(val.FROM, 'date') + " - " + this.utilService.toTimeZoneDateFormat(val.TO, 'date');
              filterInfo[key_] = modVal;
              callback(filterInfo);
            }
            else if (controls[key].question_component.question.locale != undefined && controls[key].question_component.question.locale.format != undefined && controls[key].question_component.question.outPutFormat != undefined && controls[key].question_component.question.outPutFormat) {
              filterInfo[key_] = val;
              callback(filterInfo);
            }
            else if (val && controls[key].question_component.question.singleDatePicker) {
              let modVal = this.utilService.toTimeZoneDateFormat(val, 'date')
              filterInfo[key_] = modVal;
              callback(filterInfo);
            }
          })
        } else if (condition_ && controls[key].question_component.question.controlType === "monthYearPicker") {
          this.baseService.asyncLanguageProcess(question.label).then((res: any) => {
            let key_ = res;
            let val = get_(this.kxFilter['filterVal'], key);
            if (val) {
              let modVal = this.utilService.toTimeZoneDateFormat(val, 'monthYear');
              filterInfo[key_] = modVal;
              callback(filterInfo);
            }
          })
        }
      });

      console.log("filterPrintInfo", filterInfo);
      this._currentData.filterPrintInfo = filterInfo;
      // if (data.noComplexSearch == undefined) {
      //     //support for complex search
      //     if (this.complexSearchRef != undefined && this.complexSearchRef != undefined && this.complexSearchRef.config != undefined && this.complexSearchRef.config.searchField != undefined) {
      //         this.baseService.asyncLanguageProcess(this.complexSearchRef.config.searchField.label).then((res: any) => {
      //             if (this.complexSearchRef.finalFilterVal != undefined && this.complexSearchRef.finalFilterVal) {
      //                 let obj = {};
      //                 obj[res] = this.complexSearchRef.finalFilterVal;
      //                 filterInfo = { ...filterInfo, ...obj };
      //             }
      //         });
      //         // let complexSearch = {}

      //     }
      // }

    }
  }


  onPageChanged(page) {
    console.log("page no is", page);
    this._editableGridData.page_no = page.page - 1;
    this._currentData.saveFilterKey = true;
    if (this._currentData['page_no'] != undefined) {
      delete this._currentData['page_no'];
    }
    if (this._currentData['page_size'] != undefined) {
      delete this._currentData['page_size'];
    }
    this._currentData['stopPageUpdate'] = true;
    this.dataIndex = 0;
    this.eg_grid_data = [];
    if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.hasOwnProperty('APIresource')) {
      if (this._editableGridData.existingFilter) {

      }
      this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : undefined, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : undefined);
      // this.selectedItems = [];
    }
  }


  resetFilter(filter, flag?) {
    this._currentData.saveFilterKey = true;
    this.dataIndex = 0;
    this.eg_grid_data = [];
    if (this.config && this.config.filterConfig != undefined) {
      this.config.filterConfig.reset = new Date().getTime();
      this.config.filterConfig.quickReset = true;
      this.config.filterConfig = {};
      delete this._currentData.filterName;
      delete this.config.filterConfig.FilterName;
      delete this.config.filterConfig.currentFilter;
      this.config.filterConfig.submit = new Date().getTime();
    }
    console.log("Filter is", filter);
    this._editableGridData.existingFilter = typeof filter == 'string' ? filter : '';
    if (this._currentData.filterPrintInfo != undefined && this._currentData.gridData != undefined && this._currentData.gridData['filter'] != undefined) {
      this._currentData.filterPrintInfo;
      this._currentData.gridData['filter'];
    }

    // this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, "");
    if (this.searchConfig != undefined && this.searchConfig.resetQuickFilterForm) {
      this.searchConfig.resetQuickFilterForm = false;
    } else {
      this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, "", this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : this.sortObject);
    }
    this.onAllChecked(false);
    // setTimeout(() => {
    //     this.onAllChecked(false);
    // },1000)
  }

  resetQuickFilter() {
    if (this.config && this.config.filterConfig != undefined && this.config.filterConfig.FilterName != undefined) {
      this.storageService.removeData('filterConfig' + this._currentData.json, () => { });
      this.kxFilter['resetFormClick']({ resetQuickFilterForm: true });
    }
  }

  onLimit(pageSize) {
    this._currentData.saveFilterKey = true;
    if (this._currentData['page_size'] != undefined) {
      delete this._currentData['page_size'];
    }
    if (this._currentData['page_no'] != undefined) {
      delete this._currentData['page_no'];
    }
    this._currentData['stopPageUpdate'] = true;
    console.log("page no is", pageSize);
    this._editableGridData.page_no = 0;
    this._editableGridData.page_size = pageSize;
    this.dataIndex = 0;
    this.eg_grid_data = [];
    if (this._editableGridData.listBlocks && this._editableGridData.listBlocks.hasOwnProperty('APIresource')) {
      this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : undefined);
      // this.fetchData(this._editableGridData.listBlocks.APIresource.datasource)
    } else {
      // this.listen_changes.emit({ page: page, type: "page_change" })
    }
  }

  pageConfigChange(event) {
    if (event.config && event.config == "getCount") {
      this.getCount();
    }
  }
  getCount() {
    this.dataIndex = 0;
    this.eg_grid_data = [];
    this._editableGridData.noCount = false;
    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : undefined, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : undefined, this.sortObject != undefined && this.sortObject ? this.sortObject : this.sortObject);
  }

  changeDropdownValue(event, id) {
    console.log("Event - " + event + ", Id" + id);
    this._editableGridData.items[id].value = this.userForm.controls.users['controls'][id].value.value;
  }

  /*-------------------------------------------------------Calculating eval()----------------------------------------------*/
  getValue(currentFormGroup, field) {
    let item = currentFormGroup.value;
    if (field.expression != undefined) {
      if (field.expression != undefined && item != undefined) {
        return eval(field.expression);
      }
    }
  }

  /*-------------------------------------------------------Formula Calculator----------------------------------------------*/
  formulaCalculation(formObj, currentForm) {
    try {
      let formulaCode
      let formulaValList
      let formulaExpObj
      let formulaValue
      let formulaobj = {};
      formulaExpObj = formObj.value.users.forEach((element, index) => {
        if (element.isFormulaDependent != undefined && element.isFormulaDependent == true && element.id == currentForm.value.id) {
          // formulaValList = info.tests.filter(x => x.isFormulaDependent == undefined);
          formulaValList = formObj.value.users.filter(x => x.partOf == currentForm.value.partOf);
          if (formulaValList != undefined) {
            for (let j = 0; j < formulaValList.length; j++) {
              formulaCode = formulaValList[j].serviceItemCode;
              formulaValue = formulaValList[j].value;
              if (formulaValue == "" || formulaValue == null) {
                formulaobj[formulaCode] = NaN;
              }
              else {
                formulaobj[formulaCode] = Number(parseFloat(formulaValue));;
              }
            }
            if (this.getAge(currentForm.value)) {
              formulaobj['age'] = Number(parseFloat(this.getAge(currentForm.value)));//Added to set age in the formula !!!age!!!
            }
            //   formObj.editableTable.value.editableRows[index]['formulaString'] = this.formService.baseService.buildDyanamicStr(element.formula_code, { data: formulaobj });
            let formulaString = this.formService.baseService.buildDyanamicStr(element.formula_code, { data: formulaobj });
            try {
              let formulaResult = eval(formulaString);
              if (isNaN(formulaResult)) {
                this.formService.alerts.error("All required values are not filled");
                // formObj.editableTable.value.editableRows[index].value = "";
                currentForm.controls.value.setValue('');
              } else {
                // formObj.editableTable.value.editableRows[index].value = formulaResult.toFixed(2);
                currentForm.controls.value.setValue(formulaResult.toFixed(2));
                // formObj.current_form.controls.value.updateValueAndValidity();
                // formObj.current_form.controls.value.question_component.valueChange({ target: { value: formulaResult.toFixed(2) } }, formObj.current_form.controls.value.question_component.question)
              }
              this.markChecked(currentForm, index, currentForm);

            } catch (error) {
              console.error("Issue in formula type creation");
            }

          }
        }
      });
    } catch (error) {

    }

  }

  bulkformulaCalculation(formObj, currentForm, row_id) {
    try {
      let formulaCode
      let formulaValList
      let formulaExpObj
      let formulaValue
      let formulaobj = {};
      let formulaString = '';
      formulaExpObj = formObj.value.users.forEach((element, index) => {
        let currentServiceItemCode = currentForm && currentForm.serviceItemCode ? `!!!${currentForm.serviceItemCode}!!!` : '';
      if (element.isFormulaDependent != undefined && element.isFormulaDependent == true && element.formula_code != undefined && element.formula_code != "" && currentServiceItemCode && element.formula_code.includes(currentServiceItemCode)) {
          formulaValList = this.userForm.controls.users['controls'].filter(x => x.value.partOf == currentForm.partOf)
          if (formulaValList != undefined) {
            for (let j = 0; j < formulaValList.length; j++) {
              formulaCode = formulaValList[j].value.serviceItemCode;
              formulaValue = formulaValList[j].value.value;
              if (formulaValue == "" || formulaValue == null) {
                formulaobj[formulaCode] = NaN;
              }
              else {
                formulaobj[formulaCode] = Number(parseFloat(formulaValue));;
              }
            }
            if (this.getAge(currentForm)) {
              formulaobj['age'] = Number(parseFloat(this.getAge(currentForm)));//Added to set age in the formula !!!age!!!
            }
            if (element.partOf == currentForm.partOf)
              formulaString = this.formService.baseService.buildDyanamicStr(element.formula_code, { data: formulaobj });
            try {
              let formulaResult = eval(formulaString);
              if (formulaResult != undefined && isNaN(formulaResult)) {
                console.log("All required values are not filled");
                this.onItemChecked(false, index);
                // this.userForm.controls.users['controls'][index].controls.value.setValue("");
              } else if (formulaResult != undefined && formulaResult) {
                let cal_val = formulaResult.toFixed(2);
                if (cal_val)
                  this.onItemChecked(true, index);
                else
                  this.onItemChecked(false, index);
                element.value = cal_val;
                this.userForm.controls.users['controls'][index].controls.value.setValue(cal_val);
                formulaString = ""; // reset after setup

                let item = this.selectedItems.find(y => y.id == this.userForm.controls.users['controls'][index].value.id);
                if (item != undefined && item)
                  item.value = cal_val;
              } else {
                // don nothing
              }
              this.secondMarkChecked(this.userForm.controls.users['controls'][index], index, this.userForm.controls.users['controls'][index]);
            } catch (error) {
              console.error("Issue in formula type creation");
            }

          }
        }
      });
    } catch (error) {
      console.error("Issue in formula validation");
    }

  }

  getAge(element) {
    try {
      if (element.patient_age.split(",")[0].includes("Y")) {
        return element.patient_age.split(",")[0].split(" ")[0];
      }
    } catch (error) { return false }
  }

  // ------------------------------------------------------Remove row event--------------------------------------------------
  removeRow(index: number) {
    if (this._editableGridData.listBlocks.actions.length > 0) {
      this.loader.showSpinner();
      var deleteAction = this._editableGridData.listBlocks.actions[0].conditions.find(x => x['delete'] == true);
      if (deleteAction.hasOwnProperty('datasource')) {
        if (deleteAction.emitDelete != undefined && deleteAction.emitDelete) {
          let item = this.selectedItems.find(y => y.id == this.userForm.controls.users['controls'][index].value.id);
          let editableGridItem = this._editableGridData.items.find(y => y.id == this.userForm.controls.users['controls'][index].value.id);
          editableGridItem = editableGridItem.value ? editableGridItem : item;
          let testIndex = this._editableGridData.items.findIndex(x => x.id == this.userForm.controls.users['controls'][index].value.id);
          let selectedTestIndex = this.selectedItems.findIndex(x => x.id == this.userForm.controls.users['controls'][index].value.id);
          let temp = editableGridItem;
          if (deleteAction.datasource.valueToSend != undefined && deleteAction.datasource.valueToSend.length > 0) {
            editableGridItem = {};
            for (let i = 0; i < deleteAction.datasource.valueToSend.length; i++) {
              editableGridItem[deleteAction.datasource.valueToSend[i]] = temp[deleteAction.datasource.valueToSend[i]];
            }
          }
          this.baseService.action(editableGridItem, deleteAction.datasource.action, deleteAction.datasource.application, deleteAction.datasource.resource, false).subscribe((res) => {
            console.log("respponse is", res);
            if (res.errCode == 0) {
              console.log("Object " + this.userForm, "Editable, " + "Response" + res);
              editableGridItem.value = "";
              item ? item.value = "" : "";
              this.userForm.controls.users['controls'][index].value.value = "";
              this.userForm.controls.users['controls'][index].controls.value.setValue("");
              if (this.userForm.controls.users['controls'][index].value.resultType == 'numeric') {
                this.userForm.controls.users['controls'][index].controls.abnormalValueInterpretation.setValue("");
                this.userForm.controls.users['controls'][index].controls.isResultCritical.setValue(false);
              }
              if (this.userForm.controls.users['controls'][index].value.resultType == 'advancetext') {
                this.userForm.controls.users['controls'][index].controls.componentName.setValue("");
                this.userForm.controls.users['controls'][index].controls.formatName.setValue("");
              }
              this.selectedIndices[index] = false;
              testIndex = selectedTestIndex > -1 ? selectedTestIndex : testIndex;
              this.selectedItems.splice(testIndex, 1);
              this.formService.alerts.success(res.message);
            } else if (res.errCode == -1) {
              this.formService.alerts.error(res.message);
            }
          }, (err) => {
            console.log("respponse is", err);
          })
          this.loader.hideSpinner();
          return false;
        }
      }
    }
  }

  iconRedirect(currentFormGroup, event) {
    let item = currentFormGroup.value;
    event.route.banner.datasource.args = this.baseService.buildDyanamicStr(event.route.banner.datasource.args, { data: item });
    let queryParams = {
      "banner": JSON.stringify(event.route.banner),
      "returnUrl": this.Router.url,
      "key": item.id,
      "query_params": event.route.banner.datasource.args
    };
    if (event.required_rowData != undefined && event.required_rowData) {
      sessionStorage.setItem('currentData', JSON.stringify(item))
    }
    this.Router.navigate([event.route.redirectLink], { queryParams: queryParams });
  }

  emitEllipseId(item, action) {
    switch (action.action) {
      case 'popup_form': {
        this.popupFormSetup(item, action);
        break;
      }
      // case "confirm":{
      //   this.confirmBoxResource(item.value, action);
      //   break;
      // }
      case "custom": {
        const rowData = item?.getRawValue ? item.getRawValue() : item?.value;
        if (action.required_rowData && rowData) {
          sessionStorage.setItem('currentData', JSON.stringify(rowData));
        }
        if (action.route_path) {
          this.baseService.redirectToOtherPage(action.route_path, rowData);
        }
        break;
      }
      default: {
        //do nothing
      }
    }
  }
  popupFormSetup(item, action) {
    if (action.selector != undefined) {
      let size = this.baseService.getModalSize(action['popup']['size'] ? action['popup']['size'] : '');
      let obj = {
        data: {
          "selector": action.selector,
          "item": item.getRawValue(),
          "action": action,
          "currentForm": item,
          "form": this.userForm,
          "selectedIndices": this.selectedIndices,
          "selectedItems": this.selectedItems,
          'parentForm': this.userForm != undefined ? this.userForm : false,
          "editableGrid": this._editableGridData.items
        },
        title: action.popup.title,
        size: action.popup.size
      }
      this.dialogService.open(DynamicPopUpComponent, obj).afterClosed.subscribe(res => {
        if (res) {
          item.patchValue(res);
          console.log(item);
        }
      },
        err => { console.log("err"); });
    } else if (action.datasource != undefined && action.datasource) {
      this.loader.showSpinner();
      let args = "";
      let filter = "";
      if (action.datasource.args != undefined && action.datasource.args) {
        args = action.datasource.args ? this.baseService.buildDyanamicStr(action.datasource.args, { data: item.value }) : args;
      }
      if (action.datasource.filter != undefined && action.datasource.filter) {
        filter = action.datasource.filter ? this.baseService.buildDyanamicStr(action.datasource.filter, { data: item.value }) : filter;
      }
      this.baseService.get(action.datasource.query_id, args, action.datasource.resource, action.datasource.application, filter).subscribe((res) => {
        if (res.errCode != undefined && res.errCode == 0 && res.resource[0] != undefined && res.resource[0]) {
          if (res.resource[0].clinical_remarks != undefined && res.resource[0].clinical_remarks) {
            item.value[action.key] = res.resource[0].clinical_remarks;
            item.controls[action.key].setValue(res.resource[0].clinical_remarks);
            item.controls[action.key].question_component.question.value = res.resource[0].clinical_remarks;
          }
        }
        let obj = {
          data: {
            "selector": action.selector,
            "val": item.getRawValue(),
            "action": action,
            "currentForm": item,
            "form": this.form,
            "selectedIndices": this.selectedIndices,
            "selectedItemsValue": this.selectedItems != undefined ? this.selectedItems : [],
          },
          title: action.popup.title,
          size: action.popup.size
        }
        let size = this.baseService.getModalSize(action['popup'] && action['popup']['size'] ? action['popup']['size'] : 'lg');
        this.loader.hideSpinner();
        this.smartModalService.open(DynamicPopUpComponent, obj, obj.title, size).subscribe(res => {
          if (res) {
            try {
              if (res != undefined && action.patch_keys != undefined) {
                let obj = {};
                for (let key of action.patch_keys) {
                  if (res[key.key] != undefined) {
                    obj[key.val] = res[key.key]
                  }
                }
                item.patchValue(obj);
              }
              else
                item.patchValue(res);
              console.log(item);
              if (action && action.gridRefresh != undefined && action.gridRefresh) {
                this.fetchData(this._editableGridData.listBlocks.APIresource.datasource);
              }
            } catch (error) {
              console.log("Item : " + item + ", Error : " + error);

            }
          }
        });
      });
    }
  }

  onSort(field) {
    if (!this.currentSort.has(field.key)) {
      this.currentSort.clear();
      this.currentSort.set(field.key, 1);
    } else {
      const value = this.currentSort.get(field.key);
      this.currentSort.set(field.key, value * -1);
    }
    let sortObject = this.mapToObj(this.currentSort);
    if (sortObject.value == '1')
      sortObject.value = 'asc';
    else
      sortObject.value = 'desc';


    this.sortObject = sortObject;
    this.dataIndex = 0;
    this.eg_grid_data = [];

    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : "", sortObject);


  }


  sortData(field?) {
    try {
      if (this.currentSort.size !== 0) {
        let sortObject = this.mapToObj(this.currentSort);
        this._editableGridData.items = this.utilService.sortData(JSON.parse(JSON.stringify(this._editableGridData.items)), sortObject, field);
      }
    } catch (error) {
      console.error("Error while sorting data");
    }

  }

  mapToObj(inputMap) {
    let obj = { 'value': '', 'key': '' };
    inputMap.forEach(function (value, key) {
      obj['value'] = value;
      obj['key'] = key;
    });
    return obj;
  }

  clearSort() {
    this.sortObject = false;
    this.currentSort.clear();
    this.fetchData(this._editableGridData.listBlocks.APIresource.datasource, this._editableGridData.existingFilter ? this._editableGridData.existingFilter : null, this._editableGridData.exsitingComplexSearch ? this._editableGridData.exsitingComplexSearch : "");
  }

  getDataFn(data: any) {
    //this.page = 1; // commented because it was overriding the value provided by data grid config
    if (data.type == "form" && data.obj && data.obj.form != undefined) {
      let res = this._currentData != undefined && this._currentData.json != undefined ? this._currentData.json : '';
      this.filterFormGroup = data.obj.form;
      // this.storageService.setData('filterFormGroup' + res, this.filterFormGroup.value, () => { });
      this.dummyFilterFormGroup = this.filterFormGroup.value;

      if (this.config != undefined && this.config.filterData != undefined && Object.keys(this.config.filterData).length) {
        for (let key in this.config.filterData) {
          if (this.filterFormGroup.controls != undefined && this.filterFormGroup.controls[key] != undefined) {
            this.filterFormGroup.controls[key].setValue(this.config.filterData[key]);
          }
        }
      }
    } else if (data.type == "mapping" && data.obj && data.obj.form != undefined) {
      this.filterFormMapping = data.obj.form;
    }
    else if (data.type == "default_filter" && data.obj && data.obj.form != undefined) {
      if (this.config && this.config.default_sorted) {
        // this.applyDefaultSorting(data.obj.form)
      }
      else {
        //this.configValues.emit({ 'changePage':0});
        this.setDataForFilter(data.obj.form);
        // if(this.config.dynamic_filter == undefined){
        //     this.setDataForFilter(data.obj.form);
        // }else{
        //     this.setDataForFilter(data.obj.form);
        //     // this.bindGrid.emit(data.obj.form);
        // }
      }
    } else if (data.type == 'filter_save') {
      this.saveFilterData(data.obj, data.forUserPref != undefined ? data.forUserPref : false);
    } else if (data.type == 'changePage') {
      // this.configValues.emit({ 'changePage': data.obj.page });
    }
  }

  setDataForFilter(e) {
    if (this.defaultDynamicfilter && this.defaultDynamicfilter.data) {
      let x = '';
      for (let key in this.defaultDynamicfilter.data) {
        if (x == undefined || x == '') {
          x = key + ':' + this.defaultDynamicfilter.data[key]['value'];
        } else {
          x = x + ',' + (key + ':' + this.defaultDynamicfilter.data[key]['value']);
        }
      }

    }
  }

  saveFilterData(obj, forUserPref?) {
    // if (!forUserPref) {
    this.getTableConfig((all_resource_data) => {
      var saveData = {};
      var key = this.config.saveKey;
      if (forUserPref) {
        if (all_resource_data["account__" + key] != undefined) {
          saveData = all_resource_data["account__" + key];
        }
      } else {
        saveData = (all_resource_data) ? all_resource_data : {};
      }

      saveData["filter__"] = (saveData["filter__"] == undefined) ? [] : saveData["filter__"];
      var found = false;
      let index = 0
      if (obj.key != undefined) {
        for (index = 0; index < saveData["filter__"].length; index++) {
          var filter = saveData["filter__"][index];
          if (filter.key == obj.key) {
            found = true;
            break;
          }
        }
      }
      if (found) {
        saveData["filter__"][index] = obj;
      } else {
        if (forUserPref) {
          saveData["filter__"] = [obj]; //not pushing because it will be merged with latest data in line no 1191 in saveTableConfigData function , if we merge here duplicate filter will be created earlier it was working because of a bug where user data was coming and after it was being removed so effectively only one data was being pushed from here.
        } else {
          saveData["filter__"].push(obj);
        }

      }
      this.saveTableConfigData(saveData, () => {
        this.getSavedFilter();
      }, forUserPref);
    }, forUserPref);
    // }
    // else if (forUserPref) {
    //     if (this.config.resource != undefined) {
    //         obj["key"] = this.preferenceService.getConfigurationKey(this.config.resource);
    //         this.preferenceService.getUserPreferenceConfig(obj["key"], (saveData) => {
    //             saveData = (saveData) ? saveData : {};
    //             saveData["filter__"] = (saveData["filter__"] == undefined) ? [] : saveData["filter__"];
    //             var found = false;
    //             if (obj.key != undefined) {
    //                 for(let index = 0; index < saveData["filter__"].length; index++) {
    //                     var filter = saveData["filter__"][index];
    //                     if (filter.key == obj.key) {
    //                         found = true;
    //                         break;
    //                     }
    //                 }
    //             }
    //             if (found) {
    //                 saveData["filter__"][index] = obj;
    //             } else {
    //                 saveData["filter__"].push(obj);
    //             }
    //             this.preferenceService.saveTableConfigData(obj["key"], saveData, () => {
    //                 this.getSavedFilter();
    //             });

    //         });
    //     } else {
    //         this.alerts.error("Error saving filter");
    //     }
    // }

  }

  saveTableConfigData(data, callback: any = false, userScope?, del?) {
    var key = this.searchConfig.saveKey;
    let data__ = JSON.parse(JSON.stringify(data));
    if (userScope) {
      this.getTableConfig((all_resource_data) => {
        var account_data: any = {};
        if (all_resource_data["account__" + key] != undefined) {
          account_data = all_resource_data["account__" + key];
        }
        if (account_data.filter__ != undefined && account_data.filter__.length != undefined && account_data.filter__.length > 0) {
          if (del) {
            data__.filter__ = JSON.parse(JSON.stringify(account_data.filter__));//if it is being deleted then we get the latest data from server and then remove the key which is deleted by user
          } else {
            data__.filter__ = [...data__.filter__, ...account_data.filter__];
          }

        }
        if (data__.filter__ != undefined && data__.filter__.length != undefined && data__.filter__.length > 0) {
          data__.filter__ = data__.filter__.filter(x => x.userGroupId != undefined && x.userGroupId)
        }
        if (del) {
          //delete case
          let delIndex = data__.filter__.findIndex(x => x.key != undefined && x.key == del);
          if (delIndex > -1) {
            data__.filter__.splice(delIndex, 1);
          } else {
            this.alerts.error("ERROR");
            console.error("Deleted Filter key not found");
          }
          console.log("delIndex==>", delIndex);
        }

        key = 'account__' + key;


        account_data['filter__'] = data__.filter__;

        // this.preferenceService.getConfigurationData({ key: key }, (configdata) => { 
        // debugger;
        this.preferenceService.saveConfigurationData({ key: key }, account_data, (result) => {
          callback()
        });
        // })


      }, true);//forcing to get data from db and not use cached data in localstorage
    }
    else
      this.preferenceService.saveTableConfigData(key, data, callback);

  }

  applyFilter(filter) {
    // this.ruleEngineService.setRuleArgs(false);
    // this.ruleEngineService.reSetFilter(false);
    let res = this._currentData != undefined && this._currentData.json != undefined ? this._currentData.json : '';
    this.storageService.getData('filterConfig' + res, (data) => {
      if (data) {
        this.config.filterConfig = data;
        this.storageService.removeData('filterConfig' + res, () => { });
        // this.kxFilter['form']['resetOnlyForm']({});
        this.kxFilter['resetParams']('');
        this.storageService.getData('filterFormMapping' + res, (data_) => {
          this.filterFormMapping = data_;
        });
        // this.storageService.getData('filterFormGroup' + res, (data_) => {
        //   this.filterFormGroup = data_;
        // });
        this.storageService.removeData('filterFormMapping' + res, () => { });
        this.config.stopChangeProp = true;
        this.kxFilter['stopChangeProp'] = true;
      }
    })
    if (this.config.filterConfig && this.config.filterConfig.currentFilter != undefined && this.config.filterConfig.currentFilter == filter.key) {
      this._editableGridData.listBlocks.filter.default_open = true;
      this.kxFilter['stopChangeProp'] = false;
      this.kxFilter['resetFormClick']('');
      if (this.dummyFilterFormGroup) {
        this.filterFormGroup.setValue(this.dummyFilterFormGroup);
      }
      this.resetFilter(filter, false);
    } else {
      if (filter.data != undefined && this.filterFormMapping != undefined && this.filterFormGroup != undefined) {
        var oldFilterMapping = { ...this.filterFormMapping };
        setTimeout(() => {
          this.filterFormGroup.setValue(this.dummyFilterFormGroup);
          this.config.filterConfig = { ... this.config.filterConfig };
          this.config.filterConfig.reset = new Date().getTime();
          this.config.filterConfig.currentFilter = filter.key;
          this.config.filterConfig.FilterName = filter.name;
          this.config.filterConfig.quickReset = false;
          // if (filter.isRule != undefined && filter.isRule) {
          //     this.ruleEngineService.setRuleArgs(true);
          // }
          setTimeout(async () => {
            for (let f in filter.data) {
              if (this.filterFormGroup && this.filterFormGroup.controls && this.filterFormGroup.controls[f] != undefined && oldFilterMapping[f] != undefined) {
                if (filter.data[f]['type'] == undefined)
                  filter.data[f]['type'] = oldFilterMapping[f]['controlType'];
                // if (filter.subType != undefined && filter.subType == 'dynamic') {
                //     this.configValues.emit({ 'filterType': 'dynamic' });
                // } else {
                //     this.configValues.emit({ 'filterType': '' });
                // }
                if (filter.type != undefined && filter.subType == undefined && (oldFilterMapping[f]['controlType'] == 'dropdown' || oldFilterMapping[f]['controlType'] == 'searchselect')) {
                  //console.log("Options ", oldFilterMapping[f].options);
                  if (filter.dynamic_str) {
                    if (filter.data[f].value.indexOf('!!!') != -1)
                      filter.data[f].value = this.baseService.buildDyanamicStr(filter.data[f].value, { data: null });
                    if (this.filterFormGroup.controls[f].question_component)
                      this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                    this.filterFormGroup.controls[f].setValue(filter.data[f].value);
                  } else {
                    await oldFilterMapping[f].options.find(val => {
                      if (val[oldFilterMapping[f].getterValue] == filter.data[f].value) {
                        if (this.filterFormGroup.controls[f].question_component)
                          this.filterFormGroup.controls[f].question_component.updateDependentValue(val[oldFilterMapping[f].getterKey]);
                        this.filterFormGroup.controls[f].setValue(val[oldFilterMapping[f].getterKey]);
                      }
                    });
                  }
                } else if (oldFilterMapping[f].controlType == "daterangepicker" && !oldFilterMapping[f].singleDatePicker) {
                  let date;
                  if (filter.data[f] && filter.data[f].custom != undefined && filter.data[f].custom && filter.data[f].value != undefined) {
                    date = [dayjs().valueOf(), new Date(dayjs().add(filter.data[f].value - 1, 'days').valueOf()).setUTCHours(23, 59, 59, 999)];
                  }
                  else {
                    date = await DateRangeConfig[filter.data[f].value]();
                  }
                  if (date != undefined)
                    if (this.filterFormGroup.controls[f].question_component)
                      this.filterFormGroup.controls[f].question_component.updateDependentValue({ "FROM": date[0], "TO": date[1] });
                  if (this.filterFormGroup.controls[f].question_component.question.startKey != 'FROM') {
                    this.filterFormGroup.controls[f].setValue({ [this.filterFormGroup.controls[f].question_component.question.startKey]: date[0], [this.filterFormGroup.controls[f].question_component.question.endKey]: date[1] });
                  } else
                    this.filterFormGroup.controls[f].setValue({ "FROM": date[0], "TO": date[1] });

                } else {
                  if (this.filterFormGroup.controls[f].question_component)
                    this.filterFormGroup.controls[f].question_component.updateDependentValue(filter.data[f].value);
                  this.filterFormGroup.controls[f].setValue(filter.data[f].value);

                }
              }
            }
            this.kxFilter['stopChangeProp'] = false;
            let res = this._currentData != undefined && this._currentData.json != undefined ? this._currentData.json : '';
            let filter_ = this.filterService.bindFilterGrid(this.filterFormGroup.value);
            this.doSearch(filter_);
            // this.configValues.emit({ 'filterName': this.config.filterConfig.FilterName })
            this.config.filterConfig = { ... this.config.filterConfig };
            this._currentData.filterName = this.config.filterConfig.FilterName;
            this.storageService.setData('filterName' + res, this.config.filterConfig.FilterName, () => { });
            this.storageService.setData('filterConfig' + res, this.config.filterConfig, () => { });
            this.config.filterConfig.submit = new Date().getTime();
            this.storageService.setData('filterFormMapping' + res, this.filterFormMapping, () => { });
          })
          this.config.stopChangeProp = false;
        }, 10);
      }
    }
  }

  manageFilter() {
    if (this.searchConfig.saveKey == undefined) {
      console.error("resource not found");
    } else {
      this.getSavedFilter((filterData) => {
        let popobj = { data: { self: this, data: filterData }, title: 'Manage Your Filters', size: DialogModalSize.Sm };
        this.dialogService.open(ManageFilterComponent, popobj).afterClosed.subscribe(
          res => {
            this.getSavedFilter();
            this.resetFilter('', false);
          });

      });
    }
  }

  uncheck(index, check) {
    try {
      if (this.selectedIndices != undefined && this.selectedIndices.length != undefined && this.selectedIndices.length > 0 && this.selectedItems != undefined && this.selectedItems.length != undefined && this.selectedItems.length > 0) {
        //marking current as unchecked
        this.selectedIndices[index] = check;
        //finding current accession no
        let accessionNO = this.userForm.controls.users['controls'][index].value.accessionIdentifier;
        //removing items from selected items
        let arr = [];
        for (let item of this.selectedItems) {
          if (item.accessionIdentifier != accessionNO) {
            arr.push(item);
          }
          else if (item.accessionIdentifier == accessionNO) {
            this.selectedIndices[item.index] = false;//unchecking dependents
          }
        }
        this.selectedItems = arr;
        this.form.value.tests = this.selectedItems;
        this.form.controls.tests.setValue(this.selectedItems);
        this.value = this.selectedItems; //added as it will set value to the 
      }
    } catch (error) { }
  }

  getFormattedValue(index: any, field: any, item: any) {
    if (field && field.format) { // for composite label name
      var ed_fn;
      return field.value = eval(field.format)(item);
    } else {
      field.value = item[field.key] ? item[field.key] : "";
    }
    return field;
  }

  setNestedeQuest(data, fields) {
    if (data.length != undefined && data.length > 0) {
      let arr: Array<any> = [];
      for (let i = 0; i < data.length; i++) {
        let fieldArray = [];
        if (fields != undefined && fields.length != undefined) {
          for (let j = 0; j < fields.length; j++) {
            //adding row index in each question
            fields[j]['index'] = i;
            let itemObj = Object.assign({}, fields[j]);
            if (itemObj.component_expression != undefined && this.checkExpressionForComponent(data[i], itemObj.component_expression)) {
              fieldArray.push(itemObj);
            }
            else if (!itemObj.component_expression) {
              fieldArray.push(itemObj);
            }
          }

          let obj = this.buildQuestions(fieldArray);
          obj.forEach(x => { this.getFormattedValue(i, x, this._editableGridData.items[i]) });
          if (!this._editableGridData.hasOwnProperty('cloneFields')) {
            this._editableGridData['cloneFields'] = JSON.parse(JSON.stringify(obj));
          }
          this._editableGridData.fields = obj;
          arr.push(obj);
        }

      }
      console.log("Array is as follows::", arr);
      return arr;
    }
  }

  checkExpressionForComponent(item, expression) {
    try {
      return eval(expression);
    } catch (error) {
      return false;
    }
  }

  // this method is not being called from the component
  onValueChanged(event, current_form, row_index, field) {
    if (event && field && current_form && current_form.value && current_form.value.resultType && !current_form.value.isFormulaDependent) {
      switch (current_form.value.resultType) {
        case 'numeric':
          this.markChecked(event, row_index, current_form);
          break;
        case 'singleline':
          this.markChecked(event, row_index);
          break;
        case 'dropdown':
          this.changeDropdownValue(event.val, row_index);
          this.markChecked(event, row_index);
          break;
        default:
          break;
      }
    } else if (event && event.val != '' && current_form && current_form.value && current_form.value.isFormulaDependent) {
      this.formulaCalculation(this.userForm, current_form);
    } else if (event && event.val == '') {
      this.onItemChecked(false, row_index);
    }
  }

  getTableConfigFn(key, callback) {
    this.storageService.getData(key, (data) => {
      if (data) {
        callback(data);
      } else {
        // this.getTableConfigByRequest(key, callback);
      }
    })
  }

  getFieldsOrder(key) {
    if (this._editableGridData.fields && this._editableGridData.fields.length > 0) {
      this._editableGridData.fieldsOrder = {};
      this.getTableConfigFn(key, (data) => {
        if (data && Object.keys(data).length) {
          if (data.fields_order) {
            this.getInitialFieldOrder((d) => {
              if (d) {
                Object.keys(data.fields_order).forEach((index, item) => {
                  if (this._editableGridData.fieldsOrder.hasOwnProperty(index)) {
                    this._editableGridData.fieldsOrder[index] = data.fields_order[index];
                  }
                });
                this.setFieldOrderAndVisibility();
              }
            })
          } else {
            this.getInitialFieldOrder();
          }
        } else {
          this.getInitialFieldOrder();
        }
      });
    }
  }

  getInitialFieldOrder(callBack: any = false) {
    if (this._editableGridData?.fields) {
      let isNotHiddenControl = this._editableGridData.fields.filter((d) => { return d.controlType != "hidden" });
      if (isNotHiddenControl && isNotHiddenControl.length > 0) {
        for (let i = 0; i < isNotHiddenControl.length; i++) {
          this._editableGridData.fieldsOrder[isNotHiddenControl[i].key] = i;
        }
        if (callBack) {
          callBack(true)
        }
      }
    }
  }

  addDragListner() {
    if (this._currentData.json != undefined) {
      jQuery('#editable-grid').dragableColumns({
        drag: true,
        dragClass: 'drag',
        overClass: 'over',
        movedContainerSelector: '.dnd-moved',
        onDragEnd: (fromIndex, toIndex) => {
          this.onColumnDragEnd(fromIndex, toIndex);
        }
      });
    }
  }

  onColumnDragEnd(fromIndex, toIndex) {
    /// to column
    var tobemainFieldName = jQuery('#editable-grid').find('thead tr th').eq(fromIndex).data('name');
    console.log("Drag from field", tobemainFieldName)
    let mainField = this._editableGridData.fields.find(f => { return f.key == tobemainFieldName });
    let exactPositionFromIndex = this._editableGridData.fieldsOrder[tobemainFieldName];
    if (!exactPositionFromIndex && exactPositionFromIndex != 0) {
      console.error(`Can not Drag this column not find in Order Object ${this._editableGridData.fieldsOrder}, column Name is ${tobemainFieldName}`);
      return
    }

    //from column
    var toFieldName = jQuery('#editable-grid').find('thead tr th').eq(toIndex).data('name');
    console.log("Drag to field", toFieldName)
    let exactPositionToIndex = this._editableGridData.fieldsOrder[toFieldName];
    let tobeReplacedField = this._editableGridData.fields.find(f => { return f.key == toFieldName });
    if (!exactPositionToIndex && exactPositionToIndex != 0) {
      console.error(`Can not Drag this column not find in Order Object ${this._editableGridData.fieldsOrder}, column Name is ${toFieldName}`);
      return
    }

    if (!tobeReplacedField.key) {
      this.alerts.error(`Can not drag this column.`);
      return
    }
    if (!mainField.key) {
      this.alerts.error(`Can not drag this column.`);
      return
    }
    if (toFieldName === tobemainFieldName) {
      console.error("can not drag column to itself");
      return
    }
    let checkField_mainField = this._editableGridData.fields.filter((d) => { return d.key == mainField.key }).length;
    if (checkField_mainField != 1) {
      this.alerts.error(`Dublicate keys found not able to Drag ${mainField.key}`);
      return false;
    }
    let checkField_tobeReplacedField = this._editableGridData.fields.filter((d) => { return d.key == tobeReplacedField.key }).length;
    if (checkField_tobeReplacedField != 1) {
      this.alerts.error(`Dublicate keys found not able to Drag ${tobeReplacedField.key}`);
      return false;
    }
    if (this._editableGridData.nestedFields.length > 0) {
      if (mainField.key && tobeReplacedField.key) {
        this._editableGridData.fieldsOrder[mainField.key] = exactPositionToIndex;
        this._editableGridData.fieldsOrder[tobeReplacedField.key] = exactPositionFromIndex;

        let pos_to_field = this._editableGridData.fields.findIndex((d) => { return d.key == mainField.key });

        let pos_from_field = this._editableGridData.fields.findIndex((d) => { return d.key == tobeReplacedField.key });

        this._editableGridData.fields[pos_to_field] = tobeReplacedField;
        this._editableGridData.fields[pos_from_field] = mainField;
      }
    }
    this.setFieldOrderAndVisibility((d) => {
      if (d) {
        this.getTableConfigFn(this._editableGridData.user_preference_json, (saveData) => {
          saveData.fields_order = this._editableGridData.fieldsOrder;
          this._editableGridData.drag_started = false;
          this.is_grid_sorted = false;
          this.saveTableConfigDataFn(saveData);
          this._editableGridData['dragStarted'] = true;
        });
      }
    });
  }

  setFieldOrderAndVisibility(callBack: any = false) {
    if (this._editableGridData.nestedFields.length > 0 && this._editableGridData.fields.length > 0) {
      let arr = this._editableGridData.fields.filter((d) => { return d.controlType != "hidden" && d.label != "" });
      if (arr && arr.length > 0) {
        for (let dg of arr) {
          if (dg.controlType != "hidden") {
            for (let nes of this._editableGridData.nestedFields) {
              let control = nes.find((d) => { return d.key == dg.key });
              if (control && control.controlType != "hidden") {
                control.hidden = dg.hidden;
              }
              // for(let item_ of nes){
              //   if(item_.key!=undefined && (item_.key==dg.key) && item_ && item_.controlType != "hidden"){
              //     item_.hidden = dg.hidden;
              //   }
              // }
            }
          }
        }
      }
      //debugger;
      let fields_orders = this._editableGridData.fieldsOrder;
      if (Object.keys(fields_orders).length > 0) {
        Object.keys(fields_orders).forEach((index, item) => {
          // Setting orders form user preference for header
          let field = this._editableGridData.fields.find((d) => { return d.key == index });
          if (field && fields_orders.hasOwnProperty(index)) {
            field.order = fields_orders[index]
          }
          // for(let item_ of this._editableGridData.fields){
          //   if(item_.key!=undefined && (item_.key==index)){
          //     item_.order = fields_orders[index];
          //   }
          // }

          // Setting orders form user preference for body
          for (let nes of this._editableGridData.nestedFields) {
            let control = nes.find((d) => { return d.key == index });
            if (control && fields_orders.hasOwnProperty(index)) {
              control.order = fields_orders[index]
            }
            // for(let item_ of this._editableGridData.fields){
            //   if(item_.key!=undefined && (item_.key==index)){
            //     item_.order = fields_orders[index];
            //   }
            // }
            nes.sort((a, b) => { return a.order - b.order });
          }
        })
      }
      this._editableGridData.fields.sort((a, b) => { return a.order - b.order });
      if (this._editableGridData['dragStarted']) {
        this.removeDragListner();
        this._editableGridData.tableInitalized = false;
      }
      this.checkSelectAll();
    }
    if (callBack) {
      callBack(true);
    }
  }

  removeDragListner() {
    if (jQuery('#editable-grid')) {
      var cols = jQuery('#editable-grid').find('thead tr th');
      [].forEach.call(cols, function (col) {
        jQuery(col).off();
      });
    }
  }
  checkSelectAll() {
    for (let i = 1; i < this._editableGridData.fields.length; i++) {
      if (this._editableGridData.fields[i].selected == true) {
        this._editableGridData.flag_ = true;
      } else {
        this._editableGridData.flag_ = false;
        break;
      }
    }
    if (this._editableGridData.flag_) {
      this._editableGridData.viewAll = true;
    } else {
      this._editableGridData.viewAll = false;
    }
  }

  saveTableConfigDataFn(data?) {
    if (!data) {
      data = {};
    }
    let key = this._editableGridData.resource + "_list_config";
    try {
      this.modifyFields(f => {
        if (f && f.length > 0) {
          data.fields = f;
          if (!data.hasOwnProperty('fields_order')) {
            data.fields_order = this._editableGridData.fieldsOrder;
          }
          this.storageService.setData(key, data, () => {
            console.log("user preference data", data);
            this.baseService.action({ name: key, json: JSON.stringify(data) }, "UPDATE_USER", "account-management", "user_preference").subscribe(
              (data: any) => {
                this.applyUserPreference(this._editableGridData.user_preference_json);
              }, error => {
                console.log(error);
              }
            )
          });
        }
      })
    } catch (error) {
    }
  }

  modifyFields = (callback) => {
    if (this._editableGridData.fields) {
      let arr = this._editableGridData.fields.filter((f) => { return f.controlType != "hidden" }).map((d) => { return { selected: d.selected, key: d.key, hidden: d.hidden, order: d.order } })
      callback(arr)
    }
  }

  applyUserPreference(key) {
    if (key) {
      this.getTableConfigFn(key, (data) => {
        if (data && Object.keys(data).length) {
          if (data.fields && data.fields.length > 0) {
            for (let dg of data.fields) {
              let control = this._editableGridData.fields.find((d) => { return d.key == dg.key });
              let order;
              if (control) {
                control.hidden = dg.hidden;
                control.selected = !dg.hidden;
                control.order = data.fields_order ? data.fields_order[dg.key] : null;
                // if(isOrder){
                //      order = data.fields_order[dg.key];
                //      control.order = order;
                // }
              }
            }
          }
          this.setFieldOrderAndVisibility();
        }
        this._editableGridData.user_preference_data = data;
      });
    }
  }

  // For checking provisional configuration
  checkProvisionalConfig(callback) {
    let datasource = {
      "application": "facility-management",
      "resource": "facility_config_mapping",
      "queryId": "GET_CONFIG",
      "args": "module_code:diagnostic,config_code:provisional_default_value"
    };
    this.formService.baseService.get(datasource.queryId, datasource.args, datasource.resource, datasource.application, "").subscribe(res => {
      if (res && res.errCode == 0 && res.resource != undefined && res.resource.length != undefined && res.resource.length > 0 && res.resource[0].multivalue != undefined && res.resource[0].multivalue.length != undefined && res.resource[0].multivalue.length > 0) {
        let data = res.resource[0];
        for (let val of data.multivalue) {
          if (this.validateCondition(val)) {
            return callback(true);
          } else {
            callback(false);
          }
        }
      } else {
        return callback(true);
      }
    });
  }

  // For validating config based on resource
  validateCondition(val) {
    let flag = val.id.includes("pathology");

    return flag;
  }

  checkAutoCalculationConfig() {
    let args = "config_code:auto_calculation,module_code:diagnostic";
    this.formService.baseService.get('GET_CONFIG', args, 'facility_config_mapping', 'facility-management').subscribe(res => {
      if (res.errCode == 0 && res.resource.length != undefined && res.resource[0].config_value && res.resource[0].config_value == "true") {
        this.form.controls.autoCalculationOn.setValue(true);
      } else {
        this.form.controls.autoCalculationOn.setValue(false);
      }
    });
  }

  buildQuestions(fields?: any, key?: any, InitialVal?): QuestionBase<any>[] {
    let questions = [];
    let self = InitialVal;
    return questions = fields.map((field) => {
      let question: any = {};

      if (field.blocks == undefined) {
        var componentFound = false;
        switch (field['component'] || field['controlType']) {
          case 'label':
            question = new LabelQuestion({
              key: field['name'],
              label: field['label'],
              popover: field['popover'],
              type: field['type'],
              format: field['format'],
              visible: field['visible'] != undefined ? field['visible'] : true,
              order: field['order'],
              view_required: field['view_required'] != undefined ? field['view_required'] : false,
              class_conditions: field['class_conditions'],
              grid_color_text: field['grid_color_text'],
              conditions: field['conditions'],
              flag: field['flag'],
              sortable: field['sortable'],
              conversion: field['conversion'],
              required: field['required'],
              show_popover: field['show_popover'] != undefined ? field['show_popover'] : false,
            });
            break;
          case 'textbox':
            this.formService.addDynamicValidation(field);
            question = new TextboxQuestion({
              key: field['name'],
              label: field['label'],
              type: field['type'],
              required: field['required'],
              placeholder: field['hint'],
              maxlength: field['maxlength'],
              minlength: field['minlength'],
              order: field['order'],
              pattern: field['pattern'],
              trim: field['trim'], // Not in use
              disabled: field['disabled'],
              value: field['default'] || field['default_val'] || '', // need to check for default_val
              visible: field['visible'],
              asyncValidation: field['asyncValidation'], // need to check 
              searchable: field['searchable'], // need to check 
              formAutofill: field['formAutofill'],
              conditions: field['conditions'],
              macro_support: field['macro_support'] || false,
              macro_datasource: field['macro_datasource'],
              cstm_error_msg: field['cstm_error_msg'],
              textCapitalize: field['textCapitalize'],
              asideButton: field['asideButton'],
              text_buttonIcon: field['text_buttonIcon'],
              additional_space: field['additional_space']
            });
            if (field.macro_support) {
              if (question.macro_datasource == undefined || !question.macro_datasource || (typeof (question.macro_datasource) == 'object' && Object.keys(question.macro_datasource).length === 0)) {
                question.macro_datasource = {
                  "application": "form-template-engine",
                  "resource": "macros",
                  "query_id": "GET_MACROS",
                }
              }
            }
            if (question.pattern == 'email') {
              question.pattern = '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$'
            }
            else if (question.pattern == 'url') {
              question.pattern = "^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$"
            } else if (question.pattern == 'phone') {
              question.pattern = '[0-9]*'
              question.minlength = 8,
                question.maxlength = 12
            } else if (question.pattern == 'pincode') {
              question.pattern = '[0-9]*',
                question.minlength = 6,
                question.maxlength = 6
            } else if (question.pattern == '#No') {
              question.pattern = '^[0-9+]*$'
            }
            componentFound = true;
            // console.log("Question is ", question);
            break;
          case 'dropdown':
            question = new DropdownQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              id: field['id'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              param: field['param'],
              disabled: field['disabled'],
              config: field['config'],
              order: field['order'],
              flag: field['flag'],
              conditions: field['conditions'],
              datasource: field['datasource'],
              visible: field['visible'],
              populate_field: field['populate_field'],
              req_keys: field['req_keys'],
              resource_add: field['resource_add'],
              defaultValue: field['defaultValue'],
              formAutofill: field['formAutofill'],
              format: field['format'],
              default: field['default'] || field['default_val'] || '',
              view_key: field['view_key'],
              index: field['index'],
              class_conditions: field['class_conditions'],
              stopSorting: field['stopSorting'],
              sortType: field['sort_type'],
              removeSelect: field['removeSelect'],
              sortBy: field['sortBy'],
              showMore: field['showMore']
            });
            if (question.default != null) {
              question.value = question.default.trim != undefined ? question.default.trim() : question.default;
            }

            if (this.questionsSub[question.key]) {
              this.questionsSub[question.key].unsubscribe();
            }
            if (field.datasource != undefined) {
              field.datasource.application = field.datasource.application || '';
            }
            else {
              field['datasource'] = {};
              field['datasource']['application'] = '';
            }

            // if (this.refresh) {
            //   this.questionsSub[question.key] = this.refresh.subscribe(_ => this.getDictionary(field.datasource.resource, field.datasource.query_id, field.datasource.application, '', '', field, field.datasource.read_scope_level)
            //     .subscribe(
            //       (data) => {
            //         question.options = data;
            //       }));
            // }
            if(field?.name && field?.isMethod){
              field.datasource = {
                possible_value: this.getMethodOptions(field.index)
              };
            }
            if (this.formService && field.datasource && !field.options && !(question.view_key && this.form != undefined && this.form[question.view_key] != undefined)) {
              this.formService.setdropdownOptions(field, question, self);
            }


            componentFound = true;
            break;
          case 'checkbox':
            question = new CheckboxQuestion({
              key: field['name'],
              label: field['label'],
              required: field['required'],
              order: field['order'],
              htmlText: field['htmlText'],
              text: field['label'],
              disabled: field['disabled'],
              visible: field['visible'],
              value: field['default'] || field['default_val'] || '',
              type: field['type'],
              is_rich_text: field['is_rich_text'],
              is_label_required: field['is_label_required'],
              conditions: field['conditions'],
              view_key: field['view_key'],
              format: field['format'],
              getterKey: field['getterKey'] || 'id',
              getterValue: field['getterValue'] || 'value',
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination']
            });
            if (this.questionsSub[question.key]) {
              this.questionsSub[question.key].unsubscribe();
            }
          // if (this.refresh) {
          //   this.questionsSub[question.key] = this.refresh.subscribe(_ => this.getDictionary(field['dictionaryUrl'])
          //     .subscribe(
          //       (data) => {
          //         question.options = data;
          //       }));
          // }
          // if (field['datasource'] && field['datasource'] != undefined)
          //   this.setdropdownOptions(field, question, self);
          // if (question.value == null)
          //   question.value = [];
          // componentFound = true;
          // break;
          case 'textarea':
            question = new TextareaQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              pattern: field['pattern'],
              placeholder: field['hint'],
              disabled: field['disabled'],
              visible: field['visible'],
              minlength: field['minlength'],
              formAutofill: field['formAutofill'],
              maxlength: field['maxlength'],
              macro_support: field['macro_support'] || false,
              macro_datasource: field['macro_datasource'],
              value: field['default'] || field['default_val'] || '',
              rows: field['rows'],
              conditions: field['conditions'],
              additional_space: field['additional_space']
            });
            componentFound = true;
            break;
          case 'daterangepicker':
            question = new DateRangePickerQuestion({
              key: field['name'],
              label: field['label'],
              order: field['order'],
              required: field['required'],
              disabled: field['disabled'],
              visible: field['visible'],
              conditions: field['conditions'],
              singleDatePicker: field['singleDatePicker'],
              locale: field['locale'],
              autoApply: field['autoApply'],
              showClearButton: field['showClearButton'],
              timePicker: field['timePicker'],
              timePickerSeconds: field['timePickerSeconds'],
              timePickerIncrement: field['timePickerIncrement'],
              timePicker24Hour: field['timePicker24Hour'],
              minDateNumber: field['minDateNumber'],
              minDateUnit: field['minDateUnit'],
              maxDateNumber: field['maxDateNumber'],
              maxDateUnit: field['maxDateUnit'],
              outPutFormat: field['outPutFormat'],
              showDropdowns: field['showDropdowns'],
              selected: field['selected'],
              showCustomRangeLabel: field['showCustomRangeLabel'],
              startKey: field['startKey'],
              endKey: field['endKey'],
              validations: field['validations'],
              enableInput: field['enableInput'],
              minDate: field['minDate'],
              value: field['default'] || field['default_val'] || '',
              maxDate: field['maxDate'],
              type: field['type'],
              maxSpan: field['maxSpan'],
              forceEndOfDay: field['forceEndOfDay'],
              startOfDay: field['startOfDay'],
              randomSelection: field['randomSelection'],
              defaultDaysAfter: field['defaultDaysAfter'],
              priorDate: field['priorDate'],
              subsequentDate: field['subsequentDate'],
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination']
            });
            if (question.hasOwnProperty('selected') && question.selected) {
              if (question.singleDatePicker != undefined && question.singleDatePicker == false) {
                if (question.value == null || question.value == '' || question.value == undefined) {
                  if (question.startKey && question.endKey) {
                    question.value = {}
                    question.value[question.startKey] = this.baseService.getTodayMillis();
                    question.value[question.endKey] = field['endOfDay'] ? this.baseService.getTodayEndMillis() : this.baseService.getCurrentDate()
                  } else {
                    question.value = {
                      "FROM": this.baseService.getTodayMillis(),
                      "TO": field['endOfDay'] ? this.baseService.getTodayEndMillis() : this.baseService.getCurrentDate(),
                    }
                  }
                }
              }
              else if ((question.value == null || question.value == '' || question.value == undefined) && field.incrementNo != undefined) {
                var d = new Date();
                d.setHours(0, 0, 0, 0);
                question.value = d.getTime() + (field.incrementNo * (86400 * 1000));
              }
              else if (question.value == null || question.value == '' || question.value == undefined) {
                question.value = new Date().getTime()
              }
            }
            else if (question.randomSelection != undefined && question.randomSelection) {
              question.value = this.formService.getDateRangeFromString(question.randomSelection, field)
            }
            else if (question.defaultDaysAfter != undefined && question.defaultDaysAfter) {
              question.value = this.formService.getAfterRangeFromString(question.defaultDaysAfter)
            }
            else if (question.priorDate != undefined && question.priorDate && question.subsequentDate != undefined && question.subsequentDate) {
              question.value = {
                "TO": moment().add(question.priorDate, 'days').startOf('day').valueOf(),
                "FROM": moment().subtract(question.subsequentDate, 'days').startOf('day').valueOf(),
              }
            }
            else if (question.priorDate != undefined && question.priorDate) {
              question.value = {
                "TO": moment().add(question.priorDate, 'days').startOf('day').valueOf(),
                "FROM": this.baseService.getTodayMillis(),
              }
            }
            else if (question.subsequentDate != undefined && question.subsequentDate) {
              question.value = {
                "TO": this.baseService.getTodayMillis(),
                "FROM": moment().subtract(question.subsequentDate, 'days').startOf('day').valueOf()
              }
            }


            if (question.value == null) {
              question.value = '';
            }
            componentFound = true;
            break;
          case 'edit_grid': // line 634
            console.log(field, 'field***');
            question = new EditGrid({
              label: field['label'],
              resource: field['resource'],
              data: field['data'],
              order: field['order'],
              required: field['required'],
              visible: field['visible'],
              name: field['name'],
              key: field['name'],
              value: field['data'] || [],
              emitDataOnSubmit: field['emitDataOnSubmit'],
            });
            componentFound = true;
            break;
          case 'hidden':
            question = new HiddenQuestion({
              key: field['name'],
              order: field['order'],
              label: field['label'],
              objectData: field['objectData'],
              dependent: field['dependents'],
              type: field['type'],
              fire_dependent: field['fire_dependent'],
              calculated_field_type: field['calculated_field_type'],
              calculation_formula: field['calculation_formula'],
              select_defination: field['select_defination']

              //required: field['required']
            });
            if ((field['default'] || field['default'] != undefined) || field['default_val']) {
              question.value = this.baseService.buildDyanamicStr(field['default'] || field['default_val'], {});
            }
            else if (field["name"] == 'facility_id') {
              if (this.appService.getOrganization()) {
                var x = this.appService.getOrganization();
                question.value = x.org_id;
              }
            } else if (field["name"] == 'application_id') {
              if (field["default"] == undefined)
                if (this.appService.getApplication()) {
                  question.value = this.appService.getApplication();;
                }
                else if (field["default"] == false)
                  question.value = undefined;
            }
            else {
              question.value = field['value'];
            }
            componentFound = true;
            break;
          case 'custom_form_component':
            question = new CustomFormQuestion({
              key: field['name'],
              value: field['value'],
              selector: field['selector'],
              label: field['label'],
              resource: field['resource'],
              order: field['order'],
              bannerJson: this.fieldGroup['bannerJson'],
              item_key: field['item_key']
            });
            if (question.value == null)
              question.value = [];
            componentFound = true;
            break;
          default:
            console.error('dhs Form component does not support field type ['
              + field['component'] + ']');
        }
      } else {
        question = this.formService.buildFormGroup(self, field, key);
      }
      question.labelCol = this.labelCol;
      question.className = field['class_name'];

      if (field.dependents != undefined) {
        question.dependents = field.dependents;
      }

      if (field.getterKey != undefined) {
        question.getterKey = field.getterKey;
      }

      if (field.getterValue != undefined) {
        question.getterValue = field.getterValue;
      }

      if (field.dependents != undefined) {
        question.dependents = field.dependents;
      }
      if (field.calculated_field_type != undefined && field.calculated_field_type == "Formula") {
        question.disabled = true;
      }
      //this key will send even invisible keys 
      if (field.sendInvisible != undefined && field.sendInvisible) {
        question.sendInvisible = field.sendInvisible;
      }
      //for index in editable grid
      if (field.index != undefined && field.index) {
        question['index'] = field.index;
      }
      //setting block of question
      if (key != undefined && key['block_id'] != undefined && key['block_id']) {
        question['block_id'] = key['block_id'];
      }
      //for proxy
      if (field.proxy_name != undefined && field.proxy_name) {
        question.proxy_name = field.proxy_name;;
      }
      //for visiblity of block
      if (question.key != undefined) {
        if (key != undefined) {
          question['visible'] = question['visible'] == false ? question['visible'] : key.visible;
          question['disabled'] = question['disabled'] == true ? question['disabled'] : key.disabled;
        }
        this.questionMapping[question.key] = question;
      }
      //console.log("Question is ", question);
      //for conditions
      if (question.conditions != undefined && question.conditions.length > 0) {
        // debugger; 
        this.formService.conditionShow(question, self.action);
      }
      return question;
    });
  }

  getPopover(field: any, popoverTemplate: any, details: any) {
    if (field?.value !== undefined && field?.value !== '') {
      if (typeof field.value === 'number') {
        return details;
      }
      if (typeof field.value === 'string' && field.show_popover) {
        return popoverTemplate;
      }
    }
    return null;
  }


  groupTrackById(index, data) {
    return data.value.id;
  }

  trackByValue(index, data) {
    return data.value;
  }

  getMethodValueSet() {
    this.baseService.get("get_valueset_by_id_flat", "resourceId:method,system:karexpert", "valueset", "system-management").subscribe(data => {
      if (data.errCode == 0 && data.resource?.length > 0) {
        const resource = (data && data.resource) ? data.resource : [];
        sessionStorage.setItem('methodValueSet',JSON.stringify(resource));
      }
    });
  }
}
